<template>
  <leftCenterRightContainer class="pricing-warp" v-loading.fullscreen.lock="loading" @click.native="historyInfo.currentHistoryOrderId = ''">
    <div slot="left" class="pricing-left">
      <div class="pricing-left-top">
        <custom-input @clear="searchBacklog" class="search-input" clearable v-model.trim="searchFrom.searchValue" prefix-icon="el-icon-search"
          placeholder="搜索姓名/手机" @input.native="searchBacklog"></custom-input>
          <el-dropdown @command="handleOrder" class="retail-billing">
          <custom-button type="info" plain size="big" >开单</custom-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">零售开单</el-dropdown-item>
            <el-dropdown-item command="2">转方开单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="pricing-left-middle">
        <div class="left-middle-tab">
          <el-tabs v-model="searchSource" @tab-click="backlogHandleClick">
            <el-tab-pane label="全部" name="1"></el-tab-pane>
            <el-tab-pane label="收费待办" name="2"></el-tab-pane>
            <el-tab-pane label="配方待办" name="4"></el-tab-pane>
          </el-tabs>
          <div v-if="backlogTotal > 0" class="backlog">{{ backlogTotal }}</div>
          <!-- <div class="date">{{ computedDate }}</div> -->
          <!-- <el-date-picker class="date-picker" value-format="yyyy-MM-dd" v-model="searchFrom.date" type="daterange"
            @change="dateChange">
          </el-date-picker> -->
        </div>
        <div class="date-picker">
          <el-date-picker value-format="yyyy-MM-dd" v-model="searchFrom.date" type="daterange" @change="dateChange" :clearable="false"></el-date-picker>
        </div>
        <!-- <div class="search-tips" v-if="isShowTips">搜索到{{ total }}条信息</div> -->
        <div class="middle-list" v-loadMore="getMoreList">
          <div :class="activeOrderId == item.orderId ? 'list-item active' : 'list-item'" v-for="item in backlogList"
            :key="item.orderId" @click="chooseBacklog(item.orderId, item.status)">
            <div class="item-left">
              <img v-if="item.sex == '1'" :src="imgArr.girlIcon" class="mr6 sex-icon">
              <img v-else :src="imgArr.manIcon" class="mr6 sex-icon">
              <div class="name-box text-overflow">{{ item.patientName ? item.patientName : '匿名患者' }}</div>
              <div v-if="item.isGroupOrder && item.groupOrderPlat === 1" class="ml6 size13 color949" :class="activeOrderId == item.orderId ? 'colorfff' : ''">(美团)</div>
              <div v-if="item.transferFlag" class="ml6 size13 color949" :class="activeOrderId == item.orderId ? 'colorfff' : ''">转方</div>
              <el-tooltip v-if="item.orderSourceType == '5'" effect="light" content="网诊" placement="top">
                <span v-if="item.orderSourceType == '5'" class="iconfont icon-gongzuotai status_icon"></span>
              </el-tooltip>
              <!--
              * 此功能（转单功能）目前已被配方单功能取代
              // <el-tooltip v-if="item.transferOrderStatus == '1'" effect="light" content="已转单" placement="top">
              //  <span v-if="item.transferOrderStatus == '1'" class="el-icon-sort status_icon" style="transform: rotate(90deg);"></span>
              // </el-tooltip> 
              -->
            </div>
            <div class="item-right" @click="changeBacklog(item)">
              <div v-if="item.orderSourceType == '3'" class="color6671 mr8">续方</div>
              <div>{{ item.updateDate | filterTime(systemTime) }}</div>
              <div v-for="obj in chargeStatusList" :key="obj.value">
                <div v-if="item.status == obj.value" class="item-status"
                  :style="{ color: obj.fontColor, background: obj.bgColor }">{{ item.status |
                  filterStatus }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pricing-left-bottom">
        <div class="left-bottom-title">就诊历史<span>{{ historyInfo.total || 0 }}</span></div>
        <div class="history">
          <!-- TODO： 暂时隐藏 -->
          <div class="history-scroll" v-infinite-scroll="getHistoryList" infinite-scroll-distance="4">
            <div v-for="(item, index) in historyInfo.historyList" :key="index">
              <div
                class="history-item"
                :class="{active: item.orderId === historyInfo.currentHistoryOrderId}"
                slot="reference"
                @click.stop="getCurrentHistoryOrderDetail(item)"
              >
                <el-tooltip class="item" effect="dark" :content="item.diagnosis || '-'" placement="top-end">
                  <div class="history-item-title text-overflow">{{item.diagnosis || '-'}}</div>
                </el-tooltip>
                <div class="history-item-person">
                  <div class="history-item-person-name">{{ item.doctorName || '' }}</div>
                  <div class="history-item-person-time">{{ item.date || '' }}</div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- 病例内容 -->
          <div
            class="formula_popover-tips"
            v-if="!!historyInfo.currentHistoryOrderId && currentHistoryOrderInfo"
            @click.stop=""
          >
            <div class="tips">
              <!-- 医生及金额信息 -->
              <div class="tips-top">
                <div class="tips-top-doctor">
                  <div class="tips-top-doctor-left">
                    <span class="tips-title mr12">医生</span>
                    <span>{{ currentHistoryOrderInfo.doctorName || '' }}</span>
                  </div>
                  <div class="tips-top-doctor-right">{{ currentHistoryOrderInfo.createTime || '' }}</div>
                </div>
                <div class="tips-top-money">
                  <div class="tips-top-money-left">
                    <span class="tips-title mr12">金额</span>
                    <span>￥{{ historyOrderDetailInfo.payInfo.totalPrice || '0' }}</span>
                  </div>
                  <div class="tips-top-money-right">{{ historyOrderDetailInfo.orderInfo.deptName || ''}}</div>
                </div>
              </div>
              <!-- 病例 -->
              <div class="tips-center">
                <div class="tips-center-title tips-title">病历</div>
                <div class="tips-center-content">
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.patientTell">
                    <div class="tips-center-content-label">主诉：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.patientTell || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.presentCondition">
                    <div class="tips-center-content-label">现病：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.presentCondition || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.previousHistory">
                    <div class="tips-center-content-label">既往：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.previousHistory || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.familyHistory">
                    <div class="tips-center-content-label">家族：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.familyHistory || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.allergyHistory">
                    <div class="tips-center-content-label">过敏：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.allergyHistory || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.menstrualHistory">
                    <div class="tips-center-content-label">月经史：</div>
                    <div class="tips-center-content-value" v-html="currentHistoryOrderInfo.menstrualHistory"></div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.accessoryExamination">
                    <div class="tips-center-content-label">辅助检查：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.accessoryExamination || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.physicalExamination">
                    <div class="tips-center-content-label">体格：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.physicalExamination || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.facePalpation">
                    <div class="tips-center-content-label">四诊：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.facePalpation || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.dialectical">
                    <div class="tips-center-content-label">辨证：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.dialectical || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="currentHistoryOrderInfo.diagnosis">
                    <div class="tips-center-content-label">诊断：</div>
                    <div class="tips-center-content-value">{{ currentHistoryOrderInfo.diagnosis || '' }}</div>
                  </div>
                  <div class="tips-center-content-item" v-if="!$lodash.isEmpty(currentHistoryOrderInfo.images)">
                    <div class="tips-center-content-label">附件：</div>
                    <div class="tips-center-content-value">
                      <el-image
                        class="mr6"
                        v-for="url in currentHistoryOrderInfo.images"
                        :key="url"
                        style="width: 48px; height: 48px" :src="url"
                        :preview-src-list="currentHistoryOrderInfo.images"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tips-bottom">
                <!-- 处方 -->
                 <div>
                  <!-- 中药处方 -->
                  <div class="tips-bottom-item" v-if="!$lodash.isEmpty(historyOrderDetailInfo.chooseHistory.drugItems)">
                    <div class="tips-bottom-item-mediation" v-for="(drug, index) in historyOrderDetailInfo.chooseHistory.drugItems" :key="drug.orderCaseProjectRecipeId">
                      <div class="tips-bottom-item-title tips-title">中药处方{{ historyOrderDetailInfo.chooseHistory.drugItems.length > 1 ? index + 1 : '' }}{{ drug.isYlcp == '1' ? ('(医联)' + drug.recipeName || '') : '' }}</div>
                      <div class="tips-bottom-item-mediation-list" v-if="drug.isYlcp != '1'">
                        <div
                          class="tips-bottom-item-mediation-list-item"
                          v-for="drugItem in drug.items"
                          :key="drugItem.artNo"
                        >
                          <span class="text-overflow">{{ drugItem.itemName }}</span>
                          <span>{{ drugItem.itemNum }}{{ drugItem.itemUnit }}</span>
                        </div>
                      </div>
                      <!-- 开方 -->
                      <div class="tips-bottom-item-mediation-type">
                        <span>开方：{{ drug.doseNum }}剂</span>  
                        <span>￥{{ drug.recipeAmount || 0 }}</span>
                      </div>
                      <div class="tips-bottom-item-mediation-type" v-if="drug.ingredients && drug.ingredients.length > 0">
                        <span>辅料：{{computedIngredients(drug.ingredients)}}</span>  
                      </div>
                      <!-- 是否加工：0-否，1-是 -->
                      <div class="tips-bottom-item-mediation-type" v-if="drug.processFlag=='1'">
                        <span>加工：{{drug.process.processName}}</span>  
                        <span>￥{{ drug.isYlcp === '1' ? (drug.process.processPrice || 0) * (drug.doseNum || 0) : (drug.process.processPrice || 0) }}</span>
                      </div>
                    </div>
                  </div>

                    <!-- 中成药-->
                  <div class="tips-bottom-item" v-if="!$lodash.isEmpty(historyOrderDetailInfo.chooseHistory.chineseMedicineItems)">
                    <div class="tips-bottom-item-another" v-for="(cm, ind) in historyOrderDetailInfo.chooseHistory.chineseMedicineItems" :key="cm.orderCaseProjectRecipeId">
                      <div class="tips-bottom-item-title tips-title">中成药{{ cm.length > 1 ? ind + 1 : '' }}</div>
                      <div class="tips-bottom-item-another-list">
                        <div class="tips-bottom-item-another-list-item" v-for="cmDrug in cm.items" :key="cmDrug.artNo">
                          <div class="tips-bottom-item-another-list-item-name text-overflow">{{ cmDrug.itemName || '' }}</div>
                          <div class="tips-bottom-item-another-list-item-detail">
                            <div class="detail-count">{{ cmDrug.itemNum }}{{ cmDrug.itemUnit || '次' }}</div>
                            <div class="detail-price">￥{{ computedMultiplication(cmDrug.itemNum, cmDrug.price, 2) * 1 }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 理疗 -->
                  <div class="tips-bottom-item" v-if="!$lodash.isEmpty(historyOrderDetailInfo.chooseHistory.phyItems)">
                    <div class="tips-bottom-item-another" v-for="(phy, ind) in historyOrderDetailInfo.chooseHistory.phyItems" :key="phy.orderCaseProjectRecipeId">
                      <div class="tips-bottom-item-title tips-title">理疗处方{{ phy.length > 1 ? ind + 1 : '' }}</div>
                      <div class="tips-bottom-item-another-list">
                        <div class="tips-bottom-item-another-list-item phy-item" v-for="(physioDrug,physioIndex) in phy.items" :key="physioDrug.artNo">
                          <div class="flex just-b">
                            <div class="tips-bottom-item-another-list-item-name text-overflow"> {{ physioIndex+1 }}. {{ physioDrug.itemName || '' }}</div>
                            <div class="detail-price">￥{{ computedMultiplication(physioDrug.itemNum, physioDrug.price, 2) * 1 }}</div>
                          </div>
                          <div class="mt4">
                            <span>共{{ physioDrug.physioExtendJson && physioDrug.physioExtendJson.soldNum ? physioDrug.physioExtendJson.soldNum : physioDrug.itemNum}}次</span>
                            <span v-if="physioDrug.physioExtendJson && physioDrug.physioExtendJson.executionMode ==  20" class="ml8">每次{{physioDrug.physioExtendJson.onlyNum}}组</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 套餐 -->
                  <div class="tips-bottom-item" v-if="!$lodash.isEmpty(historyOrderDetailInfo.chooseHistory.actList)">
                    <div class="tips-bottom-item-another" v-for="(act, ind) in historyOrderDetailInfo.chooseHistory.actList" :key="act.actNumber">
                      <div class="tips-bottom-item-title tips-title tips-bottom-act-title">
                        <div class="tips-bottom-act-name-warp">
                          <el-tooltip effect="dark" :content="act.actCseName" placement="top">
                            <div class="tips-bottom-act-name">{{ act.actCseName }}</div>
                          </el-tooltip>
                          <div class="tips-bottom-act-tag">活动</div>
                        </div>
                        <div class="tips-bottom-act-price">￥{{ act.totalPrice }}</div>
                      </div>
                      <div class="tips-bottom-item-another-list">
                        <div class="tips-bottom-item-another-list-item phy-item" v-for="(actProject, actProjectIndex) in act.items" :key="actProject.csdId">
                          <div class="flex just-b">
                            <div class="tips-bottom-item-another-list-item-name text-overflow"> {{ actProjectIndex + 1 }}. {{ actProject.itemName || '' }}</div>
                            <div class="detail-price">
                              <div v-if="actProject.drugType === 1" class="mt4">
                                <span>共{{ actProject.physioExtendJson && actProject.physioExtendJson.soldNum ? actProject.physioExtendJson.soldNum : actProject.itemNum}}次</span>
                                <span v-if="actProject.physioExtendJson && actProject.physioExtendJson.executionMode ==  20" class="ml8">每次{{actProject.physioExtendJson.onlyNum}}组</span>
                              </div>
                              <div v-else>{{ actProject.itemNum }}{{ actProject.itemUnit }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 非处方 -->
                  <div class="tips-bottom-item" v-if="historyOrderDetailInfo.chooseHistory.otherItems && !$lodash.isEmpty(historyOrderDetailInfo.chooseHistory.otherItems)">
                    <div class="tips-bottom-item-another" v-for="(other, ind) in historyOrderDetailInfo.chooseHistory.otherItems" :key="other.orderCaseProjectRecipeId">
                      <div class="tips-bottom-item-title tips-title">非处方{{ other.length > 1 ? ind + 1 : '' }}</div>
                      <div class="tips-bottom-item-another-list">
                        <div class="tips-bottom-item-another-list-item" v-for="otherItem in other.items" :key="otherItem.artNo">
                          <div class="tips-bottom-item-another-list-item-name text-overflow">{{ otherItem.itemName || '' }}<span v-if="otherItem.commodityType === 1">（赠品）</span></div>
                          <div class="tips-bottom-item-another-list-item-detail">
                            <div class="detail-count">{{ otherItem.itemNum }}{{ otherItem.itemUnit }}</div>
                            <div class="detail-price">￥{{ computedMultiplication(otherItem.itemNum, otherItem.price, 2) * 1 }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 复诊时间 -->
                <div class="tips-bottom-item">
                  <div class="tips-bottom-item-title tips-title">复诊时间</div>
                  <div class="tips-bottom-item-another-list" style="line-height: 20px">
                    {{ completeRevisitTime(historyOrderDetailInfo.orderInfo)}}
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 按钮 -->
            <div class="tips-btn">
              <!-- 草稿、待收（不包含部分收费）、待诊状态下，可复制历史病历 -->
              <!-- 就诊状态: -6草稿，2待就诊，3已就诊，4已收费，8待收费，9-关闭，-3已退费，-4跑单 -->
              <div class="btn" v-if="(activeOrderStatus === '-6' || (activeOrderStatus === '8' && (chargeDetail.realIncomeMoney || 0) == 0) || activeOrderStatus === '2') && !historyOrderDetailInfo.orderInfo.isGroupOrder" @click="copyHandle(currentHistoryOrderInfo)">复 制</div>
              <el-dropdown @command="printHistoryOrderHandle($event, currentHistoryOrderInfo)" style="width:90px">
                <div class="btn">打 印</div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="2">处方</el-dropdown-item>
                  <el-dropdown-item command="3">病历</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="center" class="pricing-center" v-loading="centerLoading">
      <div class="center-top">
        <span v-if="orderPayment.payStatus == '1'" class="iconfont order-status color29C0 icon-yishouf"></span>
        <span v-if="orderInfo.status == '9'" class="iconfont order-status color6671 icon-yiguanb"></span>
        <span v-if="orderPayment.payStatus == '2'" class="iconfont order-status colorF54A icon-yituif"></span>
        <span v-if="orderInfo.status == '15'" class="iconfont order-status color6671 icon-jujue"></span>
        <div class="top-title">
          <span>{{ computedOrderSourceType }}</span>
        </div>
        <div class="top-action" v-if="totalAmount">
          <el-tooltip v-if="computedOrderYbScope.ybScope" :disabled="computedOrderYbScope.ybScope == 1" :content="computedOrderYbScope.text + computedOrderYbScope.tips" placement="bottom">
            <div class="ybScope">
              <i class="el-icon-warning-outline colorFE8 mr2"></i>
            <span>{{ computedOrderYbScope.tips }}</span>
          </div>
          </el-tooltip>
          <div class="price-warp">
            <div>¥{{ totalAmount }}</div>
            <div class="size12" v-if="branchAmount !=0">已优惠￥{{branchAmount > 0 ? `+${branchAmount}` : branchAmount}}</div>
            <!-- 2026-3-26 杨蕾在群里说修改 -->
            <!-- <div class="size12" v-show="discountObj && [1,2,3].includes(discountObj.discountType)">优惠￥{{  showRealDiscountAmount }}</div>
            <div class="size12" v-show="discountObj && [4,5].includes(discountObj.discountType)">{{discountObj && discountObj.discountType == 4 ? '凑整' : '抹零' }}￥{{ showRealDiscountAmount}}</div>
            <div class="size12" v-show="couponObj && orderInfo.orderPayFlag == '0'">已优惠￥{{ couponObj && couponObj.discountAmount}}</div>
            <div class="size12" v-show="chargeDetail.useCoupon == 1 && orderInfo.orderPayFlag == '1'">已优惠￥{{ Math.abs(chargeDetail.bargainMoney)}}</div> -->
          </div>
          <custom-button @click="chargeAgin" v-if="orderInfo.status == '9' || orderInfo.status == '15'" type="primary"
            size="big">重新收费</custom-button>
          <div class="flex" v-if="orderInfo.status != '9' && orderInfo.status != '15'">
            <custom-button
              v-if="orderInfo.status == '11' && (orderInfo.orderType == '12' || orderInfo.orderType == '5' || (orderInfo.orderType == '13' && orderInfo.replenishRecipel == '1'))"
              type="primary" size="big" @click="examineContinuePass">推送订单</custom-button>
            <!-- <custom-button type="primary" size="big" v-if="orderPayment.payStatus == '0'" @click="toCharge">{{
              dealList.length > 0 ? '继续收费' : '收费' }}</custom-button> -->
            <div class="charge_btn_warp" v-if="orderPayment.payStatus == '0' && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)">
              <div class="charge_btn" @click="toCharge">{{dealList.length > 0 ? '继续收费' : '收费' }}</div>
              <el-dropdown @command="commandCharge" v-if="dealList.length == 0">
                <i class="el-icon-arrow-down el-icon--right colorfff"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">收费</el-dropdown-item>
                  <el-dropdown-item command="2" v-if="computedDealPrice">扫码支付</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>  
            <custom-button  v-if="registerWaitPayList.length > 0" type="warning" class="btn_formula" size="big" plain icon="el-icon-warning" @click="openRegisterDialog">挂号待收</custom-button>
            <!-- <custom-button v-if="orderPayment.payStatus == '0' && computedDealPrice" type="info" plain size="big" @click="toSharePay">扫码支付</custom-button> -->
            <custom-button type="info" plain size="big" :disabled="discountObj" v-if="!this.disabled && !couponObj && totalAmount > 0 && orderInfo.orderSourceType != '3' && orderInfo.orderSourceType != '5' && vipCard.discountStatus != 2 && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" @click="handleCoupon(0)">{{usableList.length > 0 ? `优惠券(${usableList.length})` : '优惠券'}}</custom-button>
            <el-dropdown class="ml10 mr10" @command="handleCoupon"  v-if="!this.disabled && couponObj && orderInfo.orderSourceType != '3' && orderInfo.orderSourceType != '5'">
              <custom-button type="info" plain size="big">管理优惠券</custom-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">修改优惠券</el-dropdown-item>
                <el-dropdown-item command="2">取消优惠券</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <custom-button v-if="discountObj && !this.disabled" type="info" plain size="big" @click="cancelDiscount">{{ discountCancelBtnMap[discountObj.discountType] }}</custom-button>
            <el-dropdown :disabled="couponObj" v-if="!discountObj && !this.disabled && orderInfo.orderSourceType != '3' && orderInfo.orderSourceType != '5' && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" class="ml10 mr10" @command="commandDiscount">
              <custom-button type="info"  plain size="big">议价</custom-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="1">凑整</el-dropdown-item>
                <el-dropdown-item command="2">抹零</el-dropdown-item>
                <el-dropdown-item command="3">自定义折扣</el-dropdown-item>
                <el-dropdown-item command="4">至尊卡折扣</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <custom-button type="info" plain size="big" v-if="jugeShowAdditionalPrescription && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)"
              @click="additionalPrescription">{{
              orderInfo.replenishRecipel == '1' || orderInfo.orderType=='5' ? '修改处方' : '补录处方' }}</custom-button>
            <custom-button v-if="formulaOrderShow" :type="presDrugDeliveryStatus === 0 ? 'success' : 'warning'" class="btn_formula" size="big" plain icon="el-icon-success" @click="showFormulaOrder">配方单</custom-button>
            <custom-button type="info" v-if="orderInfo.status == '-6'" plain size="big"
              @click="draftDelete">删除</custom-button>
            <custom-button type="info" plain size="big" v-if="orderInfo.status == '4' || orderInfo.status == '-7'" :disabled="orderInfo.isGroupOrder"
              @click="handleAgin">再来一单</custom-button>
            <custom-button @click="handleRefund" type="info" plain size="big"
              v-if="(orderInfo.status == '4') || (orderInfo.status == '8' && !computedDealPrice)">退费</custom-button>
            <custom-button @click="closePricing" type="info"
              v-if="(orderInfo.status == '2' || orderInfo.status == '8') && orderInfo.orderPayFlag == 0 && orderInfo.status != '2' && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)"
              plain size="big">关闭</custom-button>
            <custom-button
              v-if="(orderInfo.orderType == '12' || orderInfo.orderType == '13' || orderInfo.orderType=='5') && orderInfo.status == '11'"
              type="info" @click="refuseOrder" plain size="big">拒接订单</custom-button>
            <el-dropdown v-if="orderInfo.status == '4'" class="ml10" @command="orderHandleCommand">
              <custom-button type="info" plain size="big">打印</custom-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">收费小票</el-dropdown-item>
                <el-dropdown-item command="2">处方</el-dropdown-item>
                <el-dropdown-item command="3">门诊病历</el-dropdown-item>
                <el-dropdown-item v-if="showYBStatement" command="4">医保结算单</el-dropdown-item>
                <el-dropdown-item v-if="showYBStatement" command="5">医疗收费清单</el-dropdown-item>
                <el-dropdown-item command="6">发票</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <TransferOrderDialog ref="TransferOrderDialog" @success="transferOrderSuccess"></TransferOrderDialog>
          </div>
        </div>
      </div>
      <div class="center-content">
        <div class="content-tips"
          v-if="orderInfo.orderSourceType == '3' && disabled && orderPayment.payStatus == '0' && orderInfo.status != '15' && orderInfo.status != '9'">
          <i class="el-icon-warning mr2"></i>等待用户支付，不支持编辑
        </div>
        <!-- 患者医生信息 -->
        <div class="content-info">
          <div class="display-f align-i-c ">
            <div class="patient-info">
              <span v-if="patientInfo.sex == '1'" class="iconfont icon-nan colorF54A icon-sex"></span>
              <span v-else class="iconfont icon-nan color1890 icon-sex"></span>
              <el-select :disabled="disabled || orderInfo.status != '-6'" size="small" class="patientName-select"
                :popper-append-to-body="false" reserve-keyword filterable remote :remote-method="getPatientInfoByName"
                popper-class="customSelectStyle" v-model="patientInfo.patientName" placeholder="姓名"
                @change="selectPatinet" @focus="patientList = []">
                <el-option class="display-f" v-for="item in patientList" :key="item.patientId" :value="item.patientId">
                  <span style="width: 96px; display:inline-block" class="mr12 text-overflow">{{ item.patientName
                    }}</span>
                  <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                  <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth
                    }}月</span>
                  <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                </el-option>
              </el-select>
              <div :class="disabled || orderInfo.status != '-6' ? 'sex disabled' : 'sex'">{{ patientInfo.sex == '1' ?
                '女'
                : '男' }}</div>
              <div :class="disabled || orderInfo.status != '-6' ? 'sex disabled' : 'sex'">{{ patientInfo.age }}岁</div>
              <div :class="disabled || orderInfo.status != '-6' ? 'sex disabled' : 'sex'">{{ patientInfo.ageMth }}月</div>
              <el-select :disabled="disabled || orderInfo.status != '-6'" size="small" class="phone-select"
                :popper-append-to-body="false" filterable remote :remote-method="getPatientInfoByPhone"
                popper-class="customSelectStyle" v-model="patientInfo.phone" placeholder="手机号码" @clear="clearPatient"
                @change="selectPatinet" @focus="patientList = []">
                <el-option v-for="item in patientList" :key="item.patientId" :value="item.patientId">
                  <span style="width: 96px; display:inline-block" class="mr12">{{ item.patientName }}</span>
                  <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                  <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth
                    }}月</span>
                  <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                </el-option>
              </el-select>
              <!-- <span @click="editPatient" v-if="patientInfo.patientId && !disabled && orderInfo.status == '-6'"
                class="edit-icon iconfont icon-xiug"></span> -->
              <!-- <span @click="clearPatient" v-if="patientInfo.patientId && !disabled && orderInfo.status == '-6'"
                class="delete-icon iconfont icon-cha"></span> -->
            </div>
            <div class="deposit_warp" @click="recommendRechargeOpen" v-if="chargePotential && chargePotential.crowd > 0">
              <div> {{ chargePotential.crowd > 4 ? '续费潜力' : '充值潜力'}} </div>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div @click="handleAddPatient" v-if="(orderInfo.orderSourceType == '2' || orderInfo.orderSourceType == '6') && !patientInfo.patientId"
              class="add-patient" :class="disabled ? 'disabled ' : ''">
              <span class="iconfont icon-xinzenghuanz"></span>
            </div>
          </div>
          <div class="display-f">
            <custom-select clearable :disabled="disabled || (orderInfo.orderSourceType != '2' && orderInfo.orderSourceType != '6')" filterable class="user-select mr4" size="small"
              v-model="orderInfo.commissionDeptId" placeholder="所属医馆" :options="deptList" :configs="deptListConfig"
              @change="selectDept"></custom-select>
            <custom-select clearable :disabled="disabled || (orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" filterable class="user-select mr4" size="small"
              v-model="orderInfo.salesUserCode" placeholder="接待人" :options="userOptions" :configs="userConfig"
              @change="selectUser"></custom-select>
            <div class="doctor-info">
              <el-select :disabled="judeShowDoctorSelect" size="small" class="doctor-select"
                :popper-append-to-body="false" filterable remote :remote-method="getDoctorOption"
                popper-class="customSelectStyle" v-model="doctorInfo.doctorId" placeholder="医生" @change="selectDoctor">
                <el-option v-for="item in doctorOption" :key="item.doctorId" :value="item.doctorId"
                  :label="item.doctorName"></el-option>
              </el-select>
              <!-- 普通挂号费 只展示 -->
              <div class="registerprice" v-if="orderInfo.orderSourceType == '0' || orderInfo.orderSourceType == '5'">
                <span class="price-icon">¥</span>
                <custom-input clearable size="small" disabled v-model.trim="doctorInfo.registeredPrice"></custom-input>
              </div>
              <!-- 补录挂号费 可修改 -->
              <div class="registerprice" v-else>
                <span class="price-icon">¥</span>
                <custom-input clearable :disabled="disabled" size="small" v-model.trim="registerPrice"
                  @input="registerInput"></custom-input>
              </div>
            </div>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="drug-search" v-if="orderInfo.status != '2'">
          <el-select ref="otherSearchRef" :disabled="disabled || ([null, undefined, ''].includes(patientInfo.patientId) || [null, undefined, ''].includes(doctorInfo.doctorId)) || (orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" size="small" :popper-append-to-body="false"
            reserve-keyword filterable remote :remote-method="getOthers" popper-class="customSelectStyle"
            class="search-select" v-model="drugSearchValue" placeholder="输入其他商品或拼音码" @focus="otherOption = []"
            @change="selectOtherItem">
            <el-option disabled value="a" style="pointer-events:none; background:#F0F1F3">
              <span style="width:280px; display:inline-block" class="text-overflow">商品名称</span>
              <span style="width: 104px; display:inline-block" class="text-overflow">规格</span>
              <span style="width: 104px; display:inline-block" class="text-overflow">类型</span>
              <span style="width: 64px; display:inline-block" class="text-overflow">库存</span>
              <span style="width: 80px; display:inline-block" class="text-overflow">零售价</span>
              <span style="width: 70px; display:inline-block" class="text-overflow">医保属性</span>
              <span style="width: 80px; display:inline-block" class="text-overflow">spuId</span>
            </el-option>
            <el-option v-for="item in otherOption" :key="item.itemId" :value="item.itemId">
              <span class="text-overflow" style="width:280px; display:inline-block">{{ item.itemName }}</span>
              <span class="text-overflow" style="width: 104px; display:inline-block">{{ item.spec }}</span>
              <span class="text-overflow" style="width: 104px; display:inline-block">{{ item.firstCategoryName }}</span>
              <span class="text-overflow" style="width: 64px; display:inline-block">{{ item.inventory }}</span>
              <span class="text-overflow" style="width: 80px; display:inline-block">{{ item.price }}</span>
              <span class="text-overflow" style="width: 70px; display:inline-block">{{
               item.medicalInsuranceType ? computedDictText(item.medicalInsuranceType,ybPropertyList) : '-' }}</span>
                <span class="text-overflow" style="width: 80px; display:inline-block">{{ item.spuId }}</span>
            </el-option>
          </el-select>
          <i class="el-icon-plus icon"></i>
          <el-tooltip v-if="!disabled && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" effect="light" content="按F9触发结算" placement="bottom">
            <img :src="imgArr.shortcutKey" class="key-icon">
          </el-tooltip>
          <el-button v-if="!disabled && !([null, undefined, ''].includes(patientInfo.patientId) || [null, undefined, ''].includes(doctorInfo.doctorId)) && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" class="add_btn-combo" size="medium" icon="el-icon-present" @click="openComboSelect">活动</el-button>
        </div>
        <!-- 收费项目 -->
        <div class="project-warp">
          <div class="project-title">
            <div class="title-left">
              <div class="mr28">收费项目</div>
              <div v-if="formulaOrderShow" @click="showFormulaOrder" class="mr16" :class="disabled ? 'disabled ' : ''">
                <el-radio :disabled="disabled" v-model="computedIsProcess" label="1">加工</el-radio>
              </div>
              <div v-if="formulaOrderShow" @click="showFormulaOrder" :class="disabled ? 'disabled ' : ''">
                <el-radio :disabled="disabled" v-model="computedDelivery" label="1">快递</el-radio>
              </div>
              <!-- 相反相畏提示语判断：存在相反相畏药品，且划价单处于非已关闭、非已退费、非已拒绝 -->
              <span v-if="orderPayment.effectStatusFlag && (orderPayment.payStatus !== '2' && orderInfo.status !== '9' && orderInfo.status !== '15' )" class="tips colorFE8F">
                <i class="el-icon-warning"></i>
                <span> 请务必双签含相反相畏处方</span>
              </span>
              
              <!-- 单号 -->
               <span class="ml20" style="font-size: 13px; color:#b1b2b4;font-weight: 400;"  v-if="computedRecipes('0')[0]">{{ computedRecipes('0')[0].paymentOrderNum }}</span>
            </div>
            <div class="title-right">
              <div class="w92 tac">单价</div>
              <div class="w51 tac">数量</div>
              <div class="w38 tac">单位</div>
              <div class="w92 tac">小计</div>
              <div class="w96 tac">备注</div>
              <!-- <div class="w32 tac"></div> -->
            </div>
          </div>
          <!-- 挂号费、加工费、快递费 -->
          <div class="project-item" v-if="registerPrice || processBOS.length > 0 || drugWayDeliveryBOS.length > 0">
            <div class="charge-item" :class="disabled ? 'disabled ' : ''"
              v-if="registerPrice && orderInfo.orderSourceType != '0' && orderInfo.orderSourceType != '5' ">
              <div class="iconfont w32 tac flex-sh  color9AA0 icon-yishengg"></div>
              <div class="flex-sh w72 tac">挂号费</div>
              <div class="width-100">医生：{{ doctorInfo.doctorName }} <span v-if="orderPayment.registerRefundQuantity > 0"
                  class="refund">已退费</span></div>
              <div class="box-warp w92">{{ registerPrice }}</div>
              <div class="box-warp w52">1</div>
              <div class="box-warp w38">次</div>
              <div class="box-warp w92">{{ registerPrice }}</div>
              <custom-input :disabled="true" class="remark-warp" @input="updateData" v-model="remark"></custom-input>
            </div>
            <template v-for="process in processBOS">
              <div v-for="(processItem, processItemIndex) in process.processBOS" :key="processItem.id" class="charge-item" :class="disabled ? 'disabled ' : ''">
                <div class="iconfont w32 tac flex-sh color9AA0 icon-jiag"></div>
                <div @click="showFormulaOrder" class="tac w72 flex-sh">加工费</div>
                <div @click="showFormulaOrder" class="width-100">中药处方{{ process.orderNum }}{{ process.recipeType == '5' ? '-医联产品' : '' }}-配方单{{ processItemIndex + 1 }}：{{ processItem.processName }}，{{ processItem.dosage }}剂
                  <span v-if="processItem.processName == '熬药'">，每剂{{ processItem.bagNum }}袋，共{{ processItem.bagNumSum }}袋</span> <span v-if="!disabled" class="iconfont icon-bianj"></span><span v-if="processItem.status === 1 || processItem.dosageRefund > 0" class="refund">{{ process.recipeType == '5' ? `已退${processItem.dosageRefund}剂` : '已退' }}</span>
                </div>
                <div class="box-warp w92">{{ processItem.processPrice }}</div>
                <div class="box-warp w52">{{ process.recipeType == '5' && judgeTime ? processItem.dosage : 1 }}</div>
                <div class="box-warp w38">次</div>
                <div class="box-warp w92">{{ process.recipeType == '5' ? computedMultiplication(process.recipeType == '5' && judgeTime ? processItem.dosage : 1, processItem.processPrice) : processItem.processPrice }}</div>
                <custom-input v-model="processItem.remark" @input="updateData" :disabled="true" class="remark-warp"></custom-input>
              </div>
            </template>
            <div v-for="(item, index) in drugWayDeliveryBOS" :key="index" class="charge-item" :class="disabled ? 'disabled ' : ''">
              <div class="iconfont w32 tac flex-sh color9AA0 icon-kuaidi"></div>
              <div @click="showFormulaOrder" class="tac w72 flex-sh">快递费</div>
              <div @click="showFormulaOrder" class="width-100 display-f align-i-c">
                <span class="text-overflow" style="max-width: 205px;">{{ item.consigneeName }}{{ item.phone }}{{ item.provinceName }}{{ item.cityName }}{{ item.regionName }}{{ item.scopeName || '' }}{{ item.detailedAddress }}</span>
                <span class="iconfont icon-bianj point"></span>
                <i class="el-icon-copy-document point copy-icon" @click.stop="handleCopy(drugWayDeliveryBOS[index])"></i>
                <span v-if="item.status === 1" class="refund">已退</span>
              </div>
              <div class="box-warp w92">{{ item.price }}</div>
              <div class="box-warp w52">1</div>
              <div class="box-warp w38">次</div>
              <div class="box-warp w92">{{ item.price }}</div>
              <custom-input :disabled="true" class="remark-warp" v-model="item.remark"></custom-input>
            </div>
          </div>
          <!-- 非处方项目 -->
          <div class="project-item" :class="disabled ? 'disabled ' : ''" v-for="item in   computedRecipes('0')  "
            :key="item.recipeId">
            <div v-if="item.items.length > 0">
              <div class="item-title">
                <div>非处方项目 —— {{item.paymentOrderNum}}</div>
                <div class="action-warp">
                  <div @click="openQRCode(item.paymentOrderNum)">二维码</div>
                </div>
              </div>
              <div class="charge-item" v-for="(obj, itemIndex) in item.items" :key="obj.paymentRecipeItemId">
                <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                <div class="width-100 flex-sb-center" :class="orderInfo.orderPayFlag == '0' && computeInventory(obj) ? 'warning' : ''">
                 <div>
                  <el-tooltip v-if="orderInfo.orderPayFlag == '0' && computeInventory(obj) && obj.onSale == '1'"
                    class="item" effect="dark" content="库存不足" placement="top">
                    <span class="iconfont icon-jingg colorFE8F mr8"></span>
                  </el-tooltip>
                  <el-tooltip v-if="(obj.onSale == '0') && orderInfo.orderPayFlag == '0'" class="item" effect="dark"
                    content="本店暂无该商品" placement="top">
                    <span class="iconfont icon-tinshou colorF54A  mr8"></span>
                  </el-tooltip>
                  <span :class="orderInfo.orderPayFlag == '0' && obj.itemNum > obj.inventory ? 'warning' : ''">{{ obj.itemName }}<span v-if="obj.commodityType === 1">（赠品）</span></span>
                  <span :class="orderInfo.orderPayFlag == '0' && obj.itemNum > obj.inventory ? ' warning' : ''" class="color6671 ml8 size13">{{ obj.specifications || '' }}</span>
                  <span class="refund-warp" v-if="obj.refundItemNum > 0">已退{{ obj.refundItemNum }}{{ obj.itemUnit }}</span>
                 </div>
                  <div class="color667">{{ computedDictText(obj.medicalInsuranceType,ybPropertyList) }}</div>
                </div>
                <div class="box-warp w92">{{ obj.price }}</div>
                <custom-input :ref="'otherInput' + itemIndex" @input="updateDataNum($event, obj)" :disabled="disabled || obj.commodityType === 1"
                  class="number-warp" v-model.trim="obj.itemNum" @keydown.enter.native="numberEnter"></custom-input>
                <div class="box-warp w38">{{ obj.itemUnit }}</div>
                <div class="box-warp w92">{{ obj.totalPrice }}</div>
                <custom-input @input="updateData" :disabled="disabled" class="remark-warp" :style="obj.commodityType !== 1 ? 'width:64px' : 'width:96px'"
                  v-model.trim="obj.remark"></custom-input>
                <el-popconfirm v-if="obj.commodityType !== 1" confirm-button-text='确定' confirm-button-type="text" cancel-button-text='取消'
                  icon="el-icon-info" icon-color="red" title="是否确定删除？" @confirm="delItem('3', item, obj)">
                  <div slot="reference" class="del-warp">
                    <i class="el-icon-close"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </div>
          <!-- 理疗处方 -->
          <div class="project-item" v-for="(  item  ) in   computedRecipes('3')  " :key="item.recipeId">
            <div class="item-title">
              <div>理疗处方{{ item.orderNum }} —— {{item.paymentOrderNum}}</div>
              <div class="action-warp">
                <div @click="openQRCode(item.paymentOrderNum)" class="mr16">二维码</div>
                <div @click="handleCommand(1, item)">打印</div>
                <div v-if="!disabled && !(orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" @click="handleCommand(2, item)" class="ml16">删除</div>
              </div>
            </div>
            <div class="charge-item" :class="disabled ? 'disabled ' : ''" v-for="(  obj, itemIndex  ) in   item.items  "
              :key="obj.paymentRecipeItemId">
              <div class="w32 tac flex-sh border-r-dash">{{ itemIndex + 1 }}</div>
              <div class="flex-sb-center width-100">
                <div>
                  <!-- <span class="color6671 ml8 size13">【甲】</span> -->
                  <el-tooltip v-if="(obj.onSale == '0') && orderInfo.orderPayFlag == '0'" class="item" effect="dark"
                    content="本店暂无该商品" placement="top">
                    <span class="iconfont icon-tinshou colorF54A mr8"></span>
                  </el-tooltip>
                  <el-tooltip v-if="obj.enableStatus === 2 && obj.onSale == '1'" class="item" effect="dark"
                    content="该理疗项目已被禁用" placement="top">
                    <span class="iconfont icon-tinshou colorF54A mr8"></span>
                  </el-tooltip>
                  <span :class="obj.onSale == '0' ? 'warning' : ''">{{ obj.itemName }}</span>
                  <!-- <span class="refund">已退费</span> -->
                </div>
                <div class="color667">{{ computedDictText(obj.medicalInsuranceType,ybPropertyList) }}</div>
              </div>
              <div class="box-warp w92">{{ obj.physioExtendJson && obj.physioExtendJson.executionMode == 20 ? $bigNumber(obj.price, '*', obj.physioExtendJson.onlyNum) : obj.price  }}</div>
              <div class="number-warp disabled">{{ obj.physioExtendJson && obj.physioExtendJson.executionMode == 20 ? obj.physioExtendJson.soldNum : obj.itemNum }}</div>
              <!-- <custom-input disabled class="number-warp" v-model.trim="obj.physioExtendJson && obj.physioExtendJson.executionMode == 20 ? obj.physioExtendJson.soldNum : obj.itemNum"></custom-input> -->
              <div class="box-warp w38">{{ obj.itemUnit }}</div>
              <div class="box-warp w92">{{ obj.totalPrice }}</div>
              <custom-input @input="updateData" :disabled="disabled || (orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1)" class="remark-warp" v-model="obj.remark"></custom-input>
            </div>
            <div class="physio-total-warp" :class="disabled ? 'disabled ' : ''">总价：¥{{ item.totalPrice }}</div>
          </div>
          <!-- 中成药 -->
          <div class="project-item" v-for="(  item  ) in   computedRecipes('4')  " :key="item.recipeId">
            <div class="item-title">
              <div>中成药处方{{ item.orderNum }} —— {{item.paymentOrderNum}}</div> 
              <div class="action-warp">
                <div @click="handleCommand(1, item)">打印</div>
                <div v-if="!disabled" @click="handleCommand(2, item)" class="ml16">删除</div>
              </div>
            </div>
            <div class="charge-item" :class="disabled ? 'disabled ' : ''" v-for="(  obj, itemIndex  ) in   item.items  "
              :key="obj.paymentRecipeItemId">
              <div class="w32 tac flex-sh border-r-dash">{{ itemIndex + 1 }}</div>
              <div class="width-100 flex-sb-center">
                <!-- <span class="color6671 ml8 size13">【甲】</span> -->
               <div>
                <el-tooltip v-if="(obj.onSale == '0') && orderInfo.orderPayFlag == '0'" class="item" effect="dark"
                  content="本店暂无该商品" placement="top">
                  <span class="iconfont icon-tinshou colorF54A mr8"></span>
                </el-tooltip>
                <el-tooltip
                    v-if="(computeInventory(obj)) && orderInfo.orderPayFlag == '0' && obj.onSale == '1'"
                    class="item" effect="dark" content="库存不足" placement="top">
                    <span class="iconfont icon-jingg colorFE8F mr8"></span>
                  </el-tooltip>
                <span :class="obj.onSale == '0' ? 'warning' : ''">{{ obj.itemName }}</span>
                <span class="refund-warp" v-if="obj.refundItemNum > 0">已退{{ obj.itemNum }}{{
                    obj.itemUnit }}</span>
               </div>
                <div class="color667">{{ computedDictText(obj.medicalInsuranceType,ybPropertyList) }}</div>
              </div>
              <div class="box-warp w92">{{ obj.price }}</div>
              <custom-input disabled class="number-warp" v-model.trim="obj.itemNum"></custom-input>
              <div class="box-warp w38">{{ obj.itemUnit }}</div>
              <div class="box-warp w92">{{ obj.totalPrice }}</div>
              <custom-input @input="updateData" :disabled="disabled" class="remark-warp" v-model="obj.remark"></custom-input>
            </div>
            <div class="physio-total-warp" :class="disabled ? 'disabled ' : ''">总价：¥{{ item.totalPrice }}</div>
          </div>
          <!-- 中药处方 -->
          <div class="project-item" v-for="(  item  ) in   computedRecipes('1')  " :key="item.paymentRecipeItemId">
            <div class="item-title">
              <div class="display-f align-i-c">
                <div>中药处方{{ item.orderNum }} —— {{item.paymentOrderNum}}</div>
                <div v-if="item.isYlcp && item.isYlcp == '1'" class="combo-icon">医联</div>
                <div v-if="item.isYlcp && item.isYlcp == '1'" class="color1F23">【{{ item.recipeName }}】</div>
              </div>
              <div class="action-warp">
                <div @click="openQRCode(item.paymentOrderNum)" class="mr16">二维码</div>
                <div @click="handleCommand(1, item)">打印</div>
                <div v-if="!disabled" @click="handleCommand(2, item)" class="ml16">删除</div>
              </div>
            </div>
            <!-- 医联明细 -->
            <div v-if="item.isYlcp && item.isYlcp == '1' && !disabled">
              <div class="charge-item" :class="disabled ? 'disabled ' : ''"
                v-for="(  obj, itemIndex  ) in  computedComboItem(item.items, item.doseNum)  " :key="obj.drugId">
                <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                <div class="width-100 flex-sb-center"
                  :class="(computeInventory(obj) || obj.onSale == '0') && orderInfo.orderPayFlag == '0' ? 'warning' : ''">
                  <div>
                    <span class="color6671 mr8 size13" v-if="obj.ybCenterDrugDirectoryCategorySign">【{{
                      computedDictText(obj.ybCenterDrugDirectoryCategorySign,ybCenterDrugDirectoryCategorySignList) }}】</span>
                    <el-tooltip
                      v-if="(computeInventory(obj)) && orderInfo.orderPayFlag == '0' && obj.onSale == '1'"
                      class="item" effect="dark" content="库存不足" placement="top">
                      <span class="iconfont icon-jingg colorFE8F mr8"></span>
                    </el-tooltip>
                    <el-tooltip v-if="(obj.onSale == '0') && orderInfo.orderPayFlag == '0'" class="item" effect="dark"
                      content="本店暂无该商品" placement="top">
                      <span class="iconfont icon-tinshou colorF54A  mr8"></span>
                    </el-tooltip>
                    <span
                      :class="(computeInventory(obj)) && orderInfo.orderPayFlag == '0' ? 'warning' : ''">{{
                      obj.itemName }}</span>
                    <span class="refund-warp" v-if="obj.refundItemNum > 0">已退{{ computeDoseNum(obj) }}剂{{ obj.itemNum }}{{
                      obj.itemUnit }}</span>
                  </div>
                  <div class="color667">{{ computedDictText(obj.medicalInsuranceType,ybPropertyList) }}</div>
                </div>
                <div class="box-warp w92">{{ obj.price }}</div>
                <custom-input disabled class="number-warp" v-model.trim="obj.itemNum"></custom-input>
                <div class="box-warp w38">{{ obj.itemUnit }}</div>
                <div class="box-warp w92">{{ obj.totalPrice }}</div>
                <custom-input :disabled="disabled" class="remark-warp" v-model.trim="obj.remark"
                  @input="updateData"></custom-input>
              </div>
            </div>
            <!-- 中药明细 -->
            <div v-if="item.isYlcp && item.isYlcp == '0'">
              <div class="charge-item" :class="disabled ? 'disabled ' : ''" v-for="( obj, itemIndex ) in item.items" :key="obj.drugId">
                <div class="w32 tac flex-sh  border-r-dash">{{ itemIndex + 1 }}</div>
                <div class="flex-sb-center width-100" :class="(computeInventory(obj) || obj.onSale == '0') && orderInfo.orderPayFlag == '0' && obj.isOwned=='0' ? 'warning' : ''">
                  <div>
                    <span class="color6671 mr8 size13" v-if="obj.ybCenterDrugDirectoryCategorySign">【{{ computedDictText(obj.ybCenterDrugDirectoryCategorySign,ybCenterDrugDirectoryCategorySignList) }}】</span>
                    <el-tooltip v-if="(computeInventory(obj)) && orderInfo.orderPayFlag == '0' && obj.onSale == '1' && obj.isOwned=='0'" 
                      class="item" effect="dark" content="库存不足" placement="top">
                      <span class="iconfont icon-jingg colorFE8F mr8"></span>
                    </el-tooltip>
                    <el-tooltip v-if="(obj.onSale == '0') && orderInfo.orderPayFlag == '0' && obj.isOwned=='0'" class="item" effect="dark"
                      content="本店暂无该商品" placement="top">
                      <span class="iconfont icon-tinshou colorF54A  mr8"></span>
                    </el-tooltip>
                    <span :class="(computeInventory(obj)) && orderInfo.orderPayFlag == '0' && obj.isOwned=='0' ? 'warning' : ''">{{ obj.itemName }}</span>
                    <span v-if="obj.isOwned && obj.isOwned=='1'" class="color000 ml8 size13">【自备】</span>
                    <span v-if="obj.handling" class="color000 ml8 size13">【{{ obj.handling }}】</span>
                    <span class="refund-warp" v-if="obj.refundItemNum > 0">已退{{ computeDoseNum(obj) }}剂{{ obj.itemNum }}{{ obj.itemUnit }}</span>
                  </div>
                  <div class="color667">{{ computedDictText(obj.medicalInsuranceType,ybPropertyList) }}</div>
                </div>
                <div class="box-warp w92">{{ obj.price }}</div>
                <div class="w52 box-warp">{{ obj.itemNum }}</div>
                <div class="box-warp w38">{{ obj.itemUnit }}</div>
                <div :class="obj.isOwned=='1'?'box-warp w92 colorFE8F':'box-warp w92'">{{ obj.isOwned=='1' ? '自备' : obj.totalPrice  }}</div>
                <custom-input :disabled="disabled" class="remark-warp" v-model.trim="obj.remark"
                  @input="updateData"></custom-input>
              </div>
            </div>
            <div class="drug-warp-total" :class="disabled ? 'disabled ' : ''">
              <div class="drug-action">
                <div class="dosage-warp">
                  <el-input :disabled="disabled" v-model.trim="item.doseNum" @blur="drugDoseNumBlur($event, item)"></el-input>
                  <div class="pb3">剂</div>
                </div>
                <div v-if="item.isYlcp && item.isYlcp == '0'" class="ml24">{{ item.items.length }}味，单剂{{ item.weight }}g，合计{{ computedMultiplication(item.doseNum, item.weight) }}g；</div>
                <div v-if="item.recipeDetail" class="ml10">
                  <span v-if="item.recipeDetail.recipeMethod">{{ item.recipeDetail.recipeMethod }}</span>
                  <span v-if="item.recipeDetail.doseFrequency">，{{ item.recipeDetail.doseFrequency }}</span>
                  <span v-if="item.recipeDetail.frequency">，{{ item.recipeDetail.frequency }}</span>
                  <span v-if="item.recipeDetail.takingDosage">，{{ item.recipeDetail.takingDosage }}</span>
                  <span v-if="item.recipeDetail.mixingBagNum">，每次{{ item.recipeDetail.mixingBagNum }}袋</span>
                  <span v-if="item.recipeDetail.creamDosage">，{{ item.recipeDetail.creamDosage }}</span>
                  <span v-if="item.recipeDetail.pelletizingDosage">，{{ item.recipeDetail.pelletizingDosage }}</span>
                  <span v-if="item.recipeDetail.bakingPowderDosage">，{{ item.recipeDetail.bakingPowderDosage }}</span>
                  <span v-if="item.recipeDetail.takingDays">，{{ item.recipeDetail.takingDays }}</span>
                  <span v-if="item.recipeDetail.recipeMoment">，{{ item.recipeDetail.recipeMoment }}</span>
                  <span v-if="item.recipeDetail.applicationTime">，{{ item.recipeDetail.applicationTime }}</span>
                  <span v-if="item.recipeDetail.wrapTime">，{{ item.recipeDetail.wrapTime }}</span>
                </div>
              </div>
              <div>总价：¥{{ item.totalPrice }}</div>
            </div>
            <div class="drug_ingredient" v-if="item.ingredients && item.ingredients.length > 0">
              <div class="drug_ingredient_title">辅料</div>
              <div>{{ computedIngredients(item.ingredients) }}</div>
            </div>
          </div>

          <div class="project-item" v-for="(item) in actList" :key="item.actNumber">
            <div class="item-title">
              <div class="project_act_title">
                <div class="project_act_name">{{ item.actName }}</div>
                <div class="project_act_count">{{ item.actCount }}套￥{{ item.totalPrice }}</div>
              </div>
              <div class="action-warp">
                <div @click="handleCommand(1, item)">打印</div>
                <div v-if="!disabled" @click="removeActivity(item.actNumber)" class="ml16">删除</div>
              </div>
            </div>
            <div class="charge-item" :class="disabled ? 'disabled ' : ''" v-for="(  obj, itemIndex  ) in   item.items  "
              :key="obj.paymentRecipeItemId">
              <div class="w32 tac flex-sh border-r-dash">{{ itemIndex + 1 }}</div>
              <div class="flex-sb-center width-100" :class="orderInfo.orderPayFlag == '0' && obj.drugType != 1 && computeInventory(obj) ? 'warning' : ''">
                <div>
                  <el-tooltip v-if="orderInfo.orderPayFlag == '0' && obj.drugType != 1 && computeInventory(obj) && obj.onSale == '1'"
                    class="item" effect="dark" content="库存不足" placement="top">
                    <span class="iconfont icon-jingg colorFE8F mr8"></span>
                  </el-tooltip>
                  <el-tooltip v-if="(obj.onSale == '0') && orderInfo.orderPayFlag == '0'" class="item" effect="dark"
                    content="本店暂无该商品" placement="top">
                    <span class="iconfont icon-tinshou colorF54A mr8"></span>
                  </el-tooltip>
                  <el-tooltip v-if="obj.enableStatus === 2 && obj.onSale == '1'" class="item" effect="dark"
                    content="该理疗项目已被禁用" placement="top">
                    <span class="iconfont icon-tinshou colorF54A mr8"></span>
                  </el-tooltip>
                  <span :class="obj.onSale == '0' ? 'warning' : ''">{{ obj.itemName }}</span>
                  <!-- <span class="refund">已退费</span> -->
                </div>
                <div class="color667">{{ computedDictText(obj.medicalInsuranceType,ybPropertyList) }}</div>
              </div>
              <div class="box-warp w92">-</div>
              <div class="number-warp disabled">{{ obj.physioExtendJson && obj.physioExtendJson.executionMode == 20 ? obj.physioExtendJson.soldNum : obj.itemNum }}</div>
              <!-- <custom-input disabled class="number-warp" v-model.trim="obj.physioExtendJson && obj.physioExtendJson.executionMode == 20 ? obj.physioExtendJson.soldNum : obj.itemNum"></custom-input> -->
              <div class="box-warp w38">{{ obj.itemUnit }}</div>
              <div class="box-warp w92">{{ obj.totalPrice }}</div>
              <custom-input @input="updateData" :disabled="disabled" class="remark-warp" v-model="obj.remark"></custom-input>
            </div>
            <div class="physio-total-warp" :class="disabled ? 'disabled ' : ''">总价：¥{{ item.totalPrice }}</div>
          </div>

        </div>
        <!-- 医嘱事项 -->
        <div v-if="caseDetail.doctorAdvice" class="prescription-advice">
          <div class="advice-title">医嘱事项</div>
          <div class="advice-warp" ref="adviceTextarea">
            <el-input disabled class="advice-textarea" autosize type="textarea" v-model="caseDetail.doctorAdvice" />
          </div>
        </div>
        <!-- 患者备注 -->
        <el-input @input="updateData" :maxlength="200" :disabled="disabled" class="remark-box" size="medium"
          v-model.trim="patientRemark" placeholder="请输入患者备注信息"></el-input>
        <!-- 医馆备注 -->
        <el-input @input="updateData" :minlength="200" :disabled="disabled" class="remark-box" size="medium"
          v-model.trim="deptRemark" placeholder="请输入医馆备注信息"></el-input>
        <!-- 拒接原因 -->
        <div class="refuse-warp disabled" v-for="(  item, index  ) in refuseList  " :key="index">
          <div class="color1F23">{{ item.examineTime }} <span class="ml16">{{ item.examineBy }}</span> <span>拒接订单</span>
          </div>
          <div class="mt4">拒绝原因：{{ item.remark }}</div>
        </div>
      </div>
      <FormulaOrder ref="formulaOrder" :orderId="activeOrderId" :patientInfo="patientInfo" @success="chooseBacklog"></FormulaOrder>
      <ComboSelect ref="comboSelect" :doctorId="doctorInfo.doctorId" :source="2" @submit="submitComboSelect" @toEditPrescription="additionalPrescription"></ComboSelect>
      <!-- 弹框 -->
      <div>
        <div v-for="  item   in   levelData  " :key="item.name">
          <div v-if="visibleObj[item.name]">
            <component :is="item.dialog" v-if="visibleObj[item.name]" :ref="item.ref" :visibleObj="visibleObj" :showCancelPayBtn="showCancelPayBtn"
              @close="dialogVisible" @updateData="confirmUpdateData" @updatePage="updatePage" :dialogObj="dialogObj"
              @completeOrder="completeOrder" @yibaoPay="yibaoPay" :patientInfo="patientInfo" :title="patientDialogTitle"
              @cancelCtOrder="cancelCtOrder" @addPatientComfirm="addPatientComfirm" :addPatientType="addPatientType"
              @chargeRefundDialogConfirm="chargeRefundDialogConfirm" @getConsumeMessage="getConsumeMessage" @gjCancel="gjCancel" @closeInterval="closeInterval" @changePrePayDate="changePrePayDate" 
              @showOrHideCancelPayBtn="showOrHideCancelPayBtn" @chargeSuggestion="chargeSuggestion"></component>
          </div>
        </div>
      </div>
      <!-- 打印 -->
      <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow"
        @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
        @printSuccess="printSuccess" :isBatch="isBatch" :printListObj="printListObj" :id="printOrderId"
        :orderType="printorderType" :printType="printType" @printSuccessBatch="printSuccessBatch">
      </printDialog>
      <!-- 库存不足弹框 -->
      <inventory-tips-dialog type='charge' @savePrescription="savePrescription('1', true)"
        @closeInventoryTipsDialog="inventoryTipsDialogShow = false" :inventoryTipsDialogShow="inventoryTipsDialogShow"
        :drugList="drugList">
      </inventory-tips-dialog>
      <!-- 短信验证弹框 -->
       <SMS-verification ref="SMSDialog" v-if="SMSDialogObj.show" :show="SMSDialogObj.show" @close="SMSDialogClose" :dialogObj="SMSDialogObj" @smsVerificationConfirm="smsVerificationConfirm"></SMS-verification>
      <!-- 扫码弹框 -->
       <howmuchDialog v-if="howmuchVisibleObj.howmuchDialog" :visibleObj="howmuchVisibleObj" :dialogObj="howmuchDialogObj" @close="howmuchDialogObjClose" @updateData="couponScanSuccess"></howmuchDialog>
      <!-- 优惠券弹框 -->
      <coupon-dialog :visibleShow="couponDialogShow" :dialogObj="couponDialogObj" @close="couponDialogShow = false" @save="couponDialogConfirm"></coupon-dialog>
      <!-- 活动弹框 -->
      <ActivityDialog ref="activityDialog" @submit="activitySubmit"></ActivityDialog>
      <!-- 核销方式弹框 -->
      <cancellationCoupon-dialog v-if="cancellationCouponShow" :dialogObj="dialogObj" :visibleShow="cancellationCouponShow" @confirm="cancellationConfirm" @close="cancellationCouponClose"></cancellationCoupon-dialog>
      <!-- 优惠券列表弹框 -->
      <couponList-dialog v-if="couponListShow" :visibleShow="couponListShow" @close="couponListClose" :dialogObj="dialogObj" @save="couponDialogConfirm"></couponList-dialog>
       <!-- 充值弹框 -->
      <recommend-recharge v-if="showRechargeDialog" :chargePotential="chargePotential" :showRechargeDialog="showRechargeDialog" @updateMemberInfoHandle="updateMemberInfoHandle" @updateOrderNumHandle="updateOrderNumHandle" @showPaySuccessDialogHandle="showPaySuccessDialogHandle" @cancelHandle="recommendCancel"/>
        <!-- 支付/退费成功 -->
      <PayOrRefundSuccessDialog v-model="payOrRefundSuccessDialog.payOrRefundSuccessDialog" :orderNum="payOrRefundSuccessDialog.payOrRefundOrderNum" :memberInfo="rechargeMemberInfo" :type="payOrRefundSuccessDialog.type"/>
      <!-- 扫码支付 -->
      <SharePayDialog ref="sharePayDialog"></SharePayDialog>
      <register-dialog v-if="registerDialogObj.show" :dialogObj="registerDialogObj" @close="registerDialogClose"></register-dialog>
      <!-- 至尊卡扫码 -->
      <VipCardScan ref="vipCardScan" @scanSuccess="vipCardScanSuccess"></VipCardScan>
      <!-- 议价弹框 -->
      <bargainDialog v-if="bargainDialog.show" @close="bargainDialogClose" :bargainDialog="bargainDialog" @save="bargainDialogSave"></bargainDialog>
      <!-- 二维码 -->
      <commonQRCode ref="commonQRCode"></commonQRCode>
      <!-- 发票详情 -->
      <InvoiceDetail ref="invoiceDetail" @print="invoicePrint"></InvoiceDetail>
    </div>
    <div slot="right" class="pricing-right"> 
      <div class="right-top">
        <div :class="rightTab == 1 ? 'tab-item active' : 'tab-item'" @click="changeRightTab(1)">收费详情</div>
        <div v-if="orderInfo.orderType == '12' || orderInfo.orderType == '13' || orderInfo.images" :class="rightTab == 2 ? 'tab-item active' : 'tab-item'" @click="changeRightTab(2)">补录信息</div>
        <!-- 
        * 此功能（转单功能）目前已被配方单功能取代
        // <div v-if="orderInfo.transferOrderStatus == '1'" :class="rightTab == 3 ? 'tab-item active' : 'tab-item'" @click="changeRightTab(3)">转单信息</div> 
        -->
      </div>
      <div v-if="rightTab == 1" class="chargeDetail-warp right-content">
        <div class="order-warp">
          <div class="order-item">
            <div class="color6671">门诊单号</div>
            <div>{{ chargeDetail.uniOrderNumber }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">收费单号</div>
            <div>{{ chargeDetail.orderCombinedNum }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">就诊时间</div>
            <div>{{ chargeDetail.seeOrderDate | filterDate }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">开单时间</div>
            <div>{{ chargeDetail.paymentDate | filterDate }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">完成时间</div>
            <div>{{ chargeDetail.finishPayDate | filterDate }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">收费员</div>
            <div>{{ chargeDetail.payee }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">金额</div>
            <div>{{ chargeDetail.totalIncomeMoney }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">议价</div>
            <div v-if="discountObj && discountObj.discountType != 3" > <span v-if="-discountObj.realDiscountAmount > 0">+</span>{{ -discountObj.realDiscountAmount }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">优惠券</div>
            <div class="colorFE8F" v-if="chargeDetail.useCoupon == 1 && orderInfo.orderPayFlag == '1'">{{ chargeDetail.bargainMoney }}</div>
            <div class="colorFE8F" v-if="couponObj && orderInfo.orderPayFlag == '0'">-{{ couponObj.discountAmount}}</div>
          </div>
          <div v-if="orderInfo.isGroupOrder && orderInfo.groupOrderPlat === 1" class="order-item">
            <div class="color6671">美团商家优惠</div>
            <div v-if="![null, undefined, '', '0', 0].includes(chargeDetail.merchantDiscountAmount)">-{{ chargeDetail.merchantDiscountAmount }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">至尊卡</div>
            <div v-if="discountObj && discountObj.discountType == 3">-{{ discountObj.realDiscountAmount }}</div>
          </div>
          <div v-if="![null, undefined, ''].includes(chargeDetail.actDiscountMoney)" class="order-item">
            <div class="color6671">满额换购</div>
            <div>{{ chargeDetail.actDiscountMoney }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">应收</div>
            <div>{{ chargeDetail.shouldIncomeMoney }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">已退</div>
            <div>{{ chargeDetail.refundMoney }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">实收</div>
            <div>{{ chargeDetail.realIncomeMoney }}</div>
          </div>
          <!-- 已收费 + 已退费显示发票情况 -->
          <div class="issue" v-if="activeOrderStatus == 4 || activeOrderStatus == -7">
            <div class="issue-label">开票情况</div>
            <div class="issue-value">
              <span class="issue-value-text" :class="{'green': issueStatus !== -1}">{{ issueStatusText }}</span>
              <i class="el-icon-caret-bottom"></i>
              <div class="option">
                <div class="option-item" v-for="(item, index) in issueList" :key="index">
                  <div class="option-item-title">{{item.titleName}}</div>
                  <div class="option-item-content" v-for="items in item.orderNumbers" :key="items.orderNumber">
                    <div class="option-item-content-orderNum">{{items.orderNumber || ''}}</div>
                    <div
                      class="option-item-content-status" 
                      :class="{
                        'green': [0].includes(items.invoiceStatus),
                        'gray': [3, 6].includes(items.invoiceStatus)
                      }"
                    >{{items.statusText}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="deal-warp">
          <div class="deal-title">交易明细</div>
          <div class="deal-content">
            <div class="mb16" v-for="(  item, index  ) in   dealList  " :key="index">
              <div class="deal-item">
                <div :class="item.dealType == '1' ? 'colorF54A' : 'color29C0'">
                  <span>{{ item.dealType == '1' ? '退' : '收' }}</span>
                  <!-- refundTaskStatus: 1待退 3退款中 5成功 7失败 6取消 -->
                  <span :class="['1', '3', '7'].includes(item.refundTaskStatus) ? 'colorF54A' : 'color7a87'">{{ refundTaskStatusInfo[item.refundTaskStatus] || '' }}</span>
                </div>
                <div>¥{{ item.dealMoney }}</div>
              </div>
              <div class="deal-item color6671 size13">
                <div>{{ item.payee }} {{ item.dealDate | filterDate }} </div>
                <div> 
                  <el-tooltip v-if="item.dealWayType == '8' && item.memberPhone" class="item" effect="light" :content="item.memberPhone" placement="top-start">
                    <i class="el-icon-warning-outline mb2 mr2"></i>
                  </el-tooltip>
                  <span>{{ item.dealWayType | filterPayWay(PAY_WAY) }}{{ item.isMutualAidPay ? '共济' : '' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="rightTab == 2" class="case-warp right-content">
        <div class="case-title">病历</div>
        <div class="display-f mb4 size13 color6671">
          <div class="flex-sh "> 主诉：</div>
          <div>{{ caseDetail.patientTell }}</div>
        </div>
        <div class="display-f mb4 size13 color6671">
          <div class="flex-sh "> 辨证：</div>
          <div>{{ caseDetail.dialectical }}</div>
        </div>
        <div class="mb4 size13 display-f color6671">
          <div class="flex-sh "> 诊断：</div>
          <div>{{ caseDetail.diagnosis }}</div>
        </div>
        <div class="case-title mt10" v-if="imgLsit.length > 0">处方图片</div>
        <div>
          <el-image v-for="(  item, index  ) in   imgLsit  " :key="index"
            style="width: 44px; height: 44px;margin-right:8px" :src="item" :preview-src-list="imgLsit">
          </el-image>
        </div>
      </div>
      <div v-if="rightTab == 3" class="chargeDetail-warp right-content">
        <div class="order-warp">
          <div class="order-item">
            <div class="color6671">转单至</div>
            <div>{{ transferOrderInfo.receiveDeptName }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">转单时间</div>
            <div>{{ transferOrderInfo.transferTime }}</div>
          </div>
          <div class="order-item">
            <div class="color6671">操作人</div>
            <div>{{ transferOrderInfo.createBy }}</div>
          </div>
        </div>
      </div>
    </div>
  </leftCenterRightContainer>
</template>

<script>
import leftCenterRightContainer from '@/components/leftCenterRightContainer.vue'
import CustomInput from '@/components/CustomInput'
import CustomSelect from '@/components/CustomSelect'
import { Utils } from '@/utils/utils'
import { levelData, visibleObj } from '@/components/js/dialog'
import processingDialog from './components/processingDialog'
import deliveryDialog from './components/deliveryDialog'
import printDialog from '@/components/printDialog'
import addressDialog from './components/addressDialog.vue'
import chargeRefundDialog from './components/chargeRefundDialog.vue'
import refundItemDialog from './components/refundItemDialog.vue'
import additionalPrescriptionDialog from './components/additionalPrescriptionDialog.vue'
import SharePayDialog from '@/components/pay/sharePayDialog.vue'

import { getOutPatientListApi, quickPrescriptionApi } from '@/api/patient'
import { historyList } from "@/api/history"; // 病历请求
import { deepClone,isEmptyArray, isNull, isObject, dictText, isNullObj, debounce, validParams, msgboxWarning, timeoutTimer, delSomeObjValue,copy } from '@/utils/validateBase'
import { chargeStatusList, orderSourceTypeList } from '@/utils/const'
import { getChargeItem, saveCharge, deletePaymentItem, deletePaymentProject, draftDelete, switchOrderInfo, buyAgain, getTransferOrderInfo } from '@/api/pricingDetails'
import { patientDTO, drugDTO, doctorDTO, orderDTO, payDTO, prescriptionDTO, CommonDTO } from '@/DTO/index'
import { userList } from "@/api/user"; // 用户请求
import { computeWeight, computeRecipesTotalPricingDetails, computePricingTotalNew } from '@/utils/computePrice'
import pricingChargeDialog from './components/pricingChargeDialog.vue'
import howmuchDialog from '@/components/howmuchDialog/index'
import yibaoDialog from './components/yibaoDialog.vue'
import addPatientDialog from '@/components/addPatient'
import { positiveInteger, positiveNum } from '@/utils/regexp'
import refuseDialog from './components/refuseDialog.vue'
import { processingPrice } from "@/api/processing"; // 获取加工请求
import moment from 'moment';
import { ybCenterDrugDirectoryCategorySignList,ybPropertyList,productRechargeList,testRechargeList } from '@/utils/const';
import { Outpatient } from '@/views/DoctorWorkstation/newDiagnosis/data/dto/outPatientDto'
import { Common } from '@/views/DoctorWorkstation/newDiagnosis/data/common'
import inventoryTipsDialog from '@/components/inventoryTipsDialog/inventoryTipsDialog'
import { imgArr } from '@/assets/images/img'
import TransferOrderDialog from './components/TransferOrderDialog.vue'
import FormulaOrder from './components/FormulaOrder/FormulaOrder.vue'
import { provincesTree } from "@/api/region"; // 获取区域请求
import SMSVerification from '@/components/SMSVerification'
import couponDialog from './components/couponDialog.vue'
import ActivityDialog from './components/activityDialog.vue'
import {couponDetail, bindCoupon, unbindCoupon, getBingCoupon, getActivityList,getCouponList} from '@/api/coupon'
import cancellationCouponDialog from './components/cancellationCouponDialog'
import couponListDialog from './components/couponListDialog.vue'
import recommendRecharge from './components/recommendRecharge'
import { touchPoint,buriedPoint } from '@/api/common'
import PayOrRefundSuccessDialog from '@/views/Patient/MemberList/components/dialog/PayOrRefundSuccessDialog'
import { memberInfo, getOrderVipCardInfo,getVipCardInfo} from '@/api/member'
import { getRegisterWaitPay } from '@/api/register';
import registerDialog from './components/registerDialog'
import VipCardScan from '@/components/VipCard/VipCardScan.vue'
import bargainDialog from './components/bargainDialog.vue'
import { discountBind,discountUnbind } from '@/api/discount'
import { getRevisitRegisterPrice } from '@/api/doctor'
import commonQRCode from '@/components/commonQRCode/commonQRCode.vue'
import { saveMultipleActivity, cannelMultipleActivity } from "@/api/campaign"
import ComboSelect from '@/components/campaign/comboSelect.vue'
import InvoiceDetail from '@/components/Pricing/InvoiceDetail.vue'
export default {
  // 定义引入的组件
  components: {
    refuseDialog,
    leftCenterRightContainer,
    CustomInput,
    CustomSelect,
    processingDialog,
    deliveryDialog,
    addressDialog,
    chargeRefundDialog,
    refundItemDialog,
    additionalPrescriptionDialog,
    SharePayDialog,
    pricingChargeDialog,
    howmuchDialog,
    yibaoDialog,
    addPatientDialog,
    printDialog,
    inventoryTipsDialog,
    TransferOrderDialog,
    FormulaOrder,
    SMSVerification,
    couponDialog,
    ActivityDialog,
    cancellationCouponDialog,
    couponListDialog,
    recommendRecharge,
    PayOrRefundSuccessDialog,
    registerDialog,
    VipCardScan,
    bargainDialog,
    commonQRCode,
    ComboSelect,
    InvoiceDetail
  },
  props: {},
  data() {
    return {
      imgArr: imgArr,
      systemTime: '',//系统时间
      remark: '',
      number: '1',
      searchSource: '1',//导航栏激活 1全部 2 待办
      drugSearchValue: '',//药品搜索
      patientRemark: '',//患者备注
      deptRemark: '',//医馆备注
      searchFrom: {
        deptId: this.$session.get('deptId'),
        searchValue: '',//搜索值
        date: [],//日期
        currentPage: 1,//当前页
        pageSize: 20,//每页条数
      },
      patientList: [],//患者列表
      patientInfo: {},//患者信息
      presDrugDeliveryStatus: 0,
      processBOS: [],
      drugWayDeliveryBOS: [],
      doctorInfo: {
        doctorId: ''
      },//医生信息
      registerPrice: '',//挂号费
      isProcessing: '0',//是否加工
      isDelivery: '0',//是否配送
      rightTab: 1,//右边区域tab切换
      levelData: levelData,
      visibleObj: visibleObj,
      currentLevelData: {},//显示在最上面弹框对象信息
      backlogList: [],//待办列表
      backlogTotal: 0,//待办总数
      activeOrderId: '',//当前激活orderid
      activeOrderStatus: '', // 当前激活order的状态
      chargeStatusList: chargeStatusList,//收费状态列表
      isShowTips: false,//是否显示搜索提示
      doctorOption: [],//医生列表
      orderInfo: {},//就诊单信息
      recipesList: [],//处方信息
      actList: [],
      processingList: [],//加工信息
      deliveryObj: {},//快递信息
      orderSourceTypeList: orderSourceTypeList,//就诊来源类型
      // 就诊历史
      historyInfo: {
        currentOrderInfo: {},  // 当前所选择的患者订单信息
        pageNum: 1,  // 当前页
        total: 0,
        historyList: [],
        hasMoreHistoryList: true,
        currentHistoryOrderId: '', // 当前所选择的历史就诊单id
      },
      currentHistoryOrderInfo: {}, // 当前所选择的历史就诊单信息
      historyOrderDetailInfo: {
        chooseHistory: {},  
        orderInfo: {},
        doctorInfo: {},
        payInfo: {}
      },
      dialogObj: {},//弹框所需参数
      deptListConfig: {
        label: 'label',
        text: 'label',
        value: 'value'
      },
      deptList: JSON.parse(sessionStorage.getItem('options')), // 医馆列表
      userConfig: {
        value: 'userCode',
        label: 'nickName',
        text: 'nickName',
        disabled: 'disabled'
      },//开单人下拉配置
      userOptions: [],//开单人列表
      otherOption: [],//非处方项目列表
      totalPrice: 0,//总价
      chargeDetail: {},//收费详情
      issueList: [],// 发票情况
      issueStatus: '', // 发票状态
      issueStatusText: '', // 发票状态文字
      dealList: [],//交易记录
      refundTaskStatusInfo: {
        '1': '（待退）',
        '3': '（退款中）',
        '5': '（退款成功）',
        '7': '（退款失败）',
        '6': '（退款取消）'
      },
      ctOrderIds: [],//订单id
      orderPayment: {},//划价单数据
      disabled: false,//是否禁用
      printorderType: '',//打印处方订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
      printType: '',///打印类型 1小票 2处方
      printOrderId: '',//打印单号
      isBatch: false,
      printListObj: [],//批量打印列表
      printDialogShow: false,//打印弹框
      addPatientType: '',//患者弹框type
      patientDialogTitle: '',//患者弹框标题
      pageNumTotal: 0,//分页总页数
      interVal: null,//定时器
      loading: false,
      positiveInteger: positiveInteger,
      caseDetail: {},//病例信息
      refuseList: [],//拒绝列表
      imgLsit: [],//补录图片列表
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,
      total: 0,
      PAY_WAY: [],
      diagnosisList: [],
      diagnosis: '',
      inventoryTipsDialogShow: false,//库存不足弹框
      drugList: [],//所有药品列表
      isLoadMore: true,//是否加载更多
      isMore: false,//是否在加载更多
      transferOrderInfo: {
        receiveDeptName: '',
        transferTime: '',
        createBy: ''
      },
      centerLoading: false, // 中间部分loading
      ybPropertyList:ybPropertyList,
      prePayDate: '', // 上次发起的预支付时间
      showCancelPayBtn: false,
      SMSDialogObj:{
        show:false,
      },
      howmuchVisibleObj:{
        howmuchDialog: false
      },
      howmuchDialogObj:{
        text:'请扫描顾客优惠券券码',
        title:'优惠券核销',
      },
      couponDialogShow:false,
      couponDialogObj:{},
      couponObj:null,
      cancellationCouponShow:false,
      couponListShow:false,
      showRechargeDialog: false, // 充值弹框状态
      payOrRefundSuccessDialog: {}, // 充值成功弹框数据
      chargePotential:null,//充值潜力对象
      rechargeMemberInfo:{},
      memberInfo:{},
      registerWaitPayList:[],
      registerDialogObj:{
        show:false
      },
      totalAmount:null,
      vipCard: {
        vipCardNumber: '',
        status: '',
        discountRate: 100,
        balance: 0,
        discountStatus: 1
      },
      discountObj:null,
      bargainDialog:{
        show:false,
      },
      discountCancelBtnMap:{
        1:'取消折扣',
        2:'取消折扣',
        3:'取消至尊卡',
        4:'取消凑整',
        5:'取消抹零',
      },
      usableList:[],//可用优惠券列表
      branchAmount:0,
      giftGoodList: []
    }
  },
  //变量监听
  watch: {
    "orderInfo.orderPayFlag": {
      deep: true,
      handler(val) {
        this.disabled = (val == '1' || this.orderInfo.status == '9' || this.orderInfo.status == '15') ? true : false
      }
    },
  },
  computed: {
    //
    judgeTime(){
      return !CommonDTO.handleOldData(this.orderInfo.createTime)
    },
    //处理日期
    computedDate() {
      if (isNull(this.searchFrom.date) || this.searchFrom.date.length == 0) return;
      return `${this.$moment(this.searchFrom.date[0]).format('YY/MM/DD')} - ${this.$moment(this.searchFrom.date[1]).format('YY/MM/DD')}`
    },
    //处理处方数据
    computedRecipes() {
      let that = this
      return function (type) {
        return this.recipesList.filter(item => { return item.recipeType == type })
      }
    },
    //处理就诊来源
    computedOrderSourceType() {
      if(this.orderInfo.transferFlag){
        return '转方收费'
      }else{
        return `${isNull(dictText(this.orderInfo.orderSourceType, this.orderSourceTypeList)) ? '' : dictText(this.orderInfo.orderSourceType, this.orderSourceTypeList)}收费`
      }
    },
    //处理是否有加工
    computedIsProcess() {
      return this.processBOS.length > 0 ? '1' : '0'
    },
    //处理是否配送
    computedDelivery() {
      this.isDelivery = (isNull(this.deliveryObj) || isNullObj(this.deliveryObj)) ? '0' : '1'
      return (isNull(this.deliveryObj) || isNullObj(this.deliveryObj)) ? '0' : '1'
    },
    //乘法
    computedMultiplication() {
      let that = this
      return function (a, b, pointerNum) {
        if(isNull(a) || isNull(b)) return
        return this.$bigNumber(a, '*', b, pointerNum)
      }
    },
    //判断是否显示补录处方按钮
    jugeShowAdditionalPrescription() {
      let { status, orderSourceType, replenishRecipel, orderType } = this.orderInfo
      if ((status == '2' || status == '-6' || status == '8' || orderType == '13') && !this.disabled) {
      // if ((status == '2' || orderSourceType == '2' || replenishRecipel == '1' || orderType == '13' || status == '8') && status != '4' && status != '-7' && this.dealList.length == 0 && !this.disabled) {
        return true
      } else {
        return false
      }
    },
    //判断是否含有医保收费
    judeHasYb() {
      return this.dealList.some(item => { return item.dealWayType == '1' }) && this.orderInfo.status != '4'
    },
    //判断是否禁用选择医生
    judeShowDoctorSelect() {
      let { status, orderSourceType, orderType } = this.orderInfo
      let disStatus = ['2', '4', '-7', '9', '-4', '15']//需要禁用的状态
      let disOrderSourceType = ['0', '1'] //需要禁用的就诊来源类型:0-正常挂号，1-快捷开方，2-零售开单 3 续方
      let disOrderType = ['12'] //需要禁用的就诊单类型
      return disStatus.includes(status) || disOrderSourceType.includes(orderSourceType) || disOrderType.includes(orderType) || this.disabled ? true : false
    },
    computedDictText() {
      return function (value,list) {
        return dictText(value, list)
      }
    },
    //处理已退剂量
    computeDoseNum() {
      let that = this
      return function (obj) {
        return this.$bigNumber(isNull(obj.refundItemNum) ? 0 : obj.refundItemNum, '/', obj.itemNum)
      }
    },
    //判断交易金额
    computedDealPrice() {
      let received = 0
      let refund = 0
      this.dealList.forEach(item => {
        if (item.dealType == '1') {
          refund = this.$bigNumber(item.dealMoney, '+', refund)
        }
        if (item.dealType == '0') {
          received = this.$bigNumber(item.dealMoney, '+', received)
        }
      })
      return Utils.eq(received, refund)
    },
    //计算库存不足和禁用的医联明细
    computedComboItem() {
      return function (items, doseNum) {
        let arr = []
        if (!isEmptyArray(items) && !isNull(items)) {
          items.forEach(i => {
            if (i.onSale == '0' || Utils.gt(this.$bigNumber(i.itemNum, '*', doseNum || 1), i.inventory || 0)) {
              arr.push(i)
            }
          })
        }
        return arr
      }
    },
    //判断是否显示打印医保结算单
    showYBStatement(){
      let arr = this.dealList.filter(item=>{return item.dealWayType=='1' && item.refundFlag=='0'})
      return !isEmptyArray(arr)
    },
    // 判断配方单是否展示
    formulaOrderShow() {
      let visible = false;
      const list = this.recipesList.filter(v => { return v.recipeType !== '3' })
      const actList = this.actList.filter(v => {
        const hasOrdinary = v.items.some(drug => { return [null, 2].includes(drug.drugType) })
        return hasOrdinary
       })
      if(this.$session.get('user').companyId == 76){
        visible = false
      } else if (
        (list.length === 0 && actList.length === 0)
        ||
        ((list.length === 1 && list[0].recipeType === '0' && list[0].items.length === 0) && actList.length === 0)
        ||
        (this.orderInfo.status == '8' && !this.computedDealPrice)
        ||
        (this.orderInfo.orderSourceType === '3' && this.disabled && this.orderPayment.payStatus === '0' && this.orderInfo.status !== '15' && this.orderInfo.status !== '9')
      ) {
        visible = false
      } else {
        visible = true
      }
      return visible;
    },
    completeRevisitTime(){
      return function(orderInfo){
        if(orderInfo.revisitFlag == '0'){
          return `无需复诊;${orderInfo.revisitNotes || ''}`
        }else if(orderInfo.revisitFlag == '1'){
          return `${isNull(orderInfo.revisitTime) ? '' : orderInfo.revisitTime + ';'}${orderInfo.revisitNotes || ''}`
        }else if(orderInfo.revisitFlag == '2'){
          return `根据病情需要复诊;${orderInfo.revisitNotes || ''}`
        }else{
          return ''
        }
      }
    },
    computeInventory(){
      return function(kid){
        return kid.items && kid.items.some(v=>{ return v.itemTotal > v.inventory })
      }
    },
    computedOrderYbScope(){
      let list = this.diagnosisList
      let obj = {
        ybScope:'',
        tips:'',
        text:''
      }
      if(!isEmptyArray(list)){
        let notList = [] //不可刷医保
        let gzList = [] //个账
        let tcList = [] //统筹
        list.forEach(v=>{ 
          if(isNull(v.ybScope) || isNull(v.diagnoseCode) || v.ybScope == 3){
            notList.push(v.diagnoseName)
          }
          if(v.ybScope == 2){
            gzList.push(v.diagnoseName)
          }
          if(v.ybScope == 1){
            tcList.push(v.diagnoseName)
          }
        })
        if(!isEmptyArray(notList)){
          obj.ybScope = 3
          obj.tips = '不可刷医保'
          obj.text = notList.join(',')
        }else if(!isEmptyArray(gzList)){
          obj.ybScope = 2
          obj.tips = '仅个账'
          obj.text = gzList.join(',')
        }else if(!isEmptyArray(tcList)){
          obj.ybScope = 1
          obj.tips = '可统筹'
          obj.text = tcList.join(',')
        }
      }
      return obj
    },
    showRealDiscountAmount(){
      if(isNull(this.discountObj)){
        return ''
      }else{
        return -this.discountObj.realDiscountAmount > 0 ? `+${-this.discountObj.realDiscountAmount}` : -this.discountObj.realDiscountAmount
      }
    },
    computedIngredients(){
      return function(ingredientsTemplateDetails){
        let res =  ingredientsTemplateDetails.map(v2 => {
          let str = `${v2.oriName}${v2.oriNum}${v2.oriUnit}`;
          if (v2.oriHandling) {
            str += v2.oriHandling;
          }
          return str;
        }).join('，');
        return res
      }
    }
  },
  filters: {
    // 处理时间
    filterTime(val, systemTime) {
      let str = ''
      let todayStart = Utils.startOfDay(moment(systemTime))
      let todayEnd = Utils.endOfDay(moment(systemTime))
      if (!isNull(val)) {
        if (Utils.ge(val, todayStart) && Utils.le(val, todayEnd)) {
          str = Utils.timeFormat(val, 'HH:mm')
        } else {
          str = Utils.timeFormat(val, 'YY-MM-DD HH:mm')
        }
      }
      // return isNull(val) ? '' : Utils.timeFormat(val, 'yyyy-MM-DD HH:mm') 
      return str
    },
    //处理状态
    filterStatus(val) { return isNull(val) ? '' : dictText(val, chargeStatusList) },
    //格式化日期
    filterDate(val) { return isNull(val) ? '' : Utils.timeFormat(val, 'yyyy-MM-DD HH:mm:ss') },
    //处理支付方式
    filterPayWay(val, PAY_WAY) { return isNull(val) ? '' : dictText(val, PAY_WAY) },
  },
  // 页面初始化
  async created() {
    this.PAY_WAY = await CommonDTO.getPayWay()
    this.systemTime = CommonDTO.getSystemTimeDTO()
    this.searchFrom.date = [this.$moment(this.systemTime).format('YYYY-MM-DD'),this.$moment(this.systemTime).format('YYYY-MM-DD')]
    await this.getUserOption();
    await this.getPatientVisiting().then(async res => {
      this.getChargeItem(this.activeOrderId)
      this.getCaseDiagnosis()
    });
    this.intervalId = setInterval(() => { // 定时刷新订单
      this.searchFrom.currentPage = 1
      this.getPatientVisiting();
    }, 60000);
    //监听页面按下快捷键
    let that = this
    window.addEventListener('keydown', function (e) {
      if (e && e.key == 'F9') {
        that.handleCharge()
      }
    });
  },
  // 页面DOM加载完成
  mounted() {
    // 获取区域树
    this.getAreaTree()
  },
  //离开页面时执行
  destroyed() {
    clearInterval(this.intervalId)
    clearTimeout(this.timeoutId)
  },
  // 页面方法
  methods: {
     computeShowTotalPrice() {
      let branchAmount = 0 //优惠金额
      let status = this.orderInfo.status
      let arr1 = ['-6', '8', '2', '11', '15'] //显示待收金额的状态列表
      let arr2 = ['4', '-7', '9'] //显示应收金额的状态列表

      // 赠品优惠金额计算
      const otherGoodsRecipes = this.recipesList.find(v => { return v.recipeType === '0' })
      if (otherGoodsRecipes) {
        const giftGoodList = otherGoodsRecipes.items.filter(v => { return v.commodityType === 1 })
        branchAmount = giftGoodList.reduce((total, cur) => {
          return Math.round((total + (cur.totalPrice - (cur.itemNum * 0.01))) * 100) / 100
        }, 0)
      }
      
      if (arr1.includes(status) && this.orderInfo.orderPayFlag == '0') {
        // 草稿、待收费、待就诊并且没有生成订单 显示划价单的原价 - 使用优惠券的价格 
        let total = isNull(this.couponObj) ? this.totalPrice : this.$bigNumber(this.totalPrice,'-',this.couponObj.discountAmount)
        if (this.vipCard.vipCardNumber && this.vipCard.discountStatus == 2 && this.vipCard.discountRate != 100) {
          total = Math.round(((total - this.registerPrice) * this.vipCard.discountRate / 100 + this.registerPrice) * 100) / 100
        }
        // 如果使用折扣 - 折扣金额
        if(this.discountObj){
          total = this.$bigNumber(total,'-',this.discountObj.realDiscountAmount)
        }
        branchAmount = this.$bigNumber(branchAmount,'+',isNull(this.couponObj) ? 0 : this.couponObj.discountAmount)
        branchAmount = this.$bigNumber(branchAmount,'+',isNull(this.discountObj) ? 0 : this.discountObj.realDiscountAmount)
        this.branchAmount = -branchAmount
        
        return total;
      } else if (arr1.includes(status) && this.orderInfo.orderPayFlag == '1') {
        // 草稿、待收费、待就诊并且已经生成订单 显示划价单的应收-实收
        branchAmount = this.$bigNumber(branchAmount,'+',isNull(this.discountObj) ? 0 : this.discountObj.realDiscountAmount)
        if(!isNull(this.chargeDetail.bargainMoney) && this.chargeDetail.useCoupon == 1){
          branchAmount = this.$bigNumber(branchAmount,'+',isNull(this.chargeDetail.bargainMoney) ? 0 : -this.chargeDetail.bargainMoney)
        }
        this.branchAmount = -branchAmount
        return this.$bigNumber(this.chargeDetail.shouldIncomeMoney, '-', isNull(this.chargeDetail.realIncomeMoney) ? 0 : this.chargeDetail.realIncomeMoney)
      } else if (arr2.includes(status)) {
        branchAmount = this.$bigNumber(branchAmount,'+',isNull(this.discountObj) ? 0 : this.discountObj.realDiscountAmount)
        if(!isNull(this.chargeDetail.bargainMoney) && this.chargeDetail.useCoupon == 1){
          branchAmount = this.$bigNumber(branchAmount,'+',isNull(this.chargeDetail.bargainMoney) ? 0 : -this.chargeDetail.bargainMoney)
        }
        this.branchAmount = -branchAmount
        //已收费、已退费、已关闭：  显示应收金额
        return isNull(this.chargeDetail.shouldIncomeMoney) ? this.totalPrice : this.chargeDetail.shouldIncomeMoney
      }
    },
    getAreaTree() {
      if(!sessionStorage.getItem('nationalAreaList')) {
        provincesTree().then(res => {
          if (res.code === 200) {
            sessionStorage.setItem('nationalAreaList', JSON.stringify(res.data))
          }
        })
      }
    },
    /**
     * 滚动条分页
     */
    getMoreList() {
      let that = this
      if (this.isLoadMore && !this.isMore) {
        that.isMore = true
        that.searchFrom.currentPage += 1
        that.getPatientVisiting()
      }
    },

    /**
     * 医保支付成功
     */
    async yibaoPay(obj) {
      try {
        let { orderPayNumber, price, paySuccess, attach } = obj
        if (paySuccess == '2') {
          this.$refs.pricingChargeDialog[0].loading = false
          this.$refs.yibaoDialog[0].loading = false;
          this.$refs.yibaoDialog[0].dialogShow = false;
          this.$refs.yibaoDialog[0].settlementLoading = false;
        } else {
          let time = await CommonDTO.getSystemTimeDTO()
          let params = {
            orderPayNumber,
            payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
            paySuccess,
            amount: price,
            attach: isNull(attach) ? {} : attach
          }
          payDTO.payCallback(params).then(res => {
            if (res.code == 200) {
              this.$refs.pricingChargeDialog[0].loading = true
              this.$refs.yibaoDialog[0].yibaoStept = 3
              this.$refs.yibaoDialog[0].loading = false;
              this.$refs.yibaoDialog[0].dialogShow = false;
              this.$refs.yibaoDialog[0].settlementLoading = false;
              this.getPatientVisiting().then(res => {
                this.getChargeItem(this.activeOrderId)
              });
              this.$refs.pricingChargeDialog[0].getPayRecord().then(res => {
                let { paid, realPay } = this.$refs.pricingChargeDialog[0].payFrom
                if (Utils.ge(paid, realPay)) {
                  // 支付完成
                  this.$message.success('订单已完成');
                  this.dialogVisible('pricingChargeDialog', false);
                  this.orderHandleCommand('1');
                }
              })
            } else {
              this.$refs.pricingChargeDialog[0].loading = false;
              this.$refs.yibaoDialog[0].dialogShow = false;
              this.$refs.yibaoDialog[0].loading = false;
              this.$refs.yibaoDialog[0].settlementLoading = false;
            }
          }).catch(err => {
            this.$refs.pricingChargeDialog[0].loading = false;
            this.$refs.yibaoDialog[0].dialogShow = false;
            this.$refs.yibaoDialog[0].loading = false;
            this.$refs.yibaoDialog[0].settlementLoading = false;
          })
        }
      } catch (error) {
        this.$refs.pricingChargeDialog[0].loading = false;
        this.$refs.yibaoDialog[0].dialogShow = false;
        this.$refs.yibaoDialog[0].loading = false;
        this.$refs.yibaoDialog[0].settlementLoading = false;
      }
    },
    /**
     * 查询病例信息
     */
    getCaseDiagnosis() {
      if (isNull(this.activeOrderId)) return
      return new Promise((resolve, reject) => {
        patientDTO.getCaseDiagnosis({ orderId: this.activeOrderId }).then(res => {
          resolve(res)
          let { code, data } = res
          if (code == 200) {
            if (isNull(data)) {
              this.diagnosisList = []
              this.diagnosis = ''
            } else {
              this.diagnosisList = (isNull(data.diagnosisList)) ? [] : data.diagnosisList
              this.diagnosis = data.diagnosis
              const newDoctorAdvice = data.doctorAdvice.split('\n').filter(v => v != '')
              data.doctorAdvice = newDoctorAdvice.join('\n')
            }
            this.caseDetail = isNull(res.data) ? {} : res.data
          }
        })
      })
    },

    /**
     * 收费确认
     * obj 收费弹框传递出来的数据 如支付方式、金额、授权码
     * 执行预支付+支付
     */
    async pricingChargeConfirmfn(obj) {
      // 更新数据，拿到最新的议价后价格
      this.getChargeItem(this.activeOrderId).then(async res => {
        this.ctOrderIds = obj.ctOrderIds
        let { payWay } = obj
        if (payWay == '1' && !Utils.eq(obj.price, 0)) {
          // 医保支付
          this.dialogObj.doctorInfo = this.doctorInfo
          this.dialogObj.patientInfo = this.patientInfo
          this.dialogObj.recipesList = this.recipesList
          this.dialogObj.ctOrderIds = this.ctOrderIds
          this.dialogObj.diagnosisList = this.diagnosisList
          this.dialogObj.diagnosis = this.diagnosis
          this.dialogObj.orderId = this.activeOrderId
          this.$refs.pricingChargeDialog[0].loading = false
          this.dialogVisible('yibaoDialog', true)
        }else if(payWay == '8'){
          this.SMSDialogObj.show = true
          this.SMSDialogObj.price = obj.price
          this.SMSDialogObj.phone = this.patientInfo.phone
          this.$nextTick(()=>{
            this.$refs.SMSDialog.getWalletAmount(this.patientInfo.phone)
          })
        }else if (payWay == '3' && !Utils.eq(obj.price, 0)) {
          // 好码齐
          this.$refs.pricingChargeDialog[0].loading = false
          this.dialogObj.price = obj.price
          this.dialogVisible('howmuchDialog', true)
        } else {
          this.handlePay(obj)
        }
      })
    },
    /**
    * 关闭定时器并刷新
    */
    closeInterval() {
      clearTimeout(this.timeoutId1)
      clearTimeout(this.timeoutId2)
      this.$refs.pricingChargeDialog[0].loading = false
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });
      this.$refs.pricingChargeDialog[0].getPayRecord().then(res => {
        let { paid, realPay } = this.$refs.pricingChargeDialog[0].payFrom
        if (Utils.ge(paid, realPay)) {
          // 支付完成
          this.$message.success('订单已完成');
          this.dialogVisible('pricingChargeDialog', false);
          this.orderHandleCommand('1');
        }
      })
    },
    /**
    * 好码齐扫码成功
    * 好码齐支付
    * obj
    */
    howmuchDialogFn: debounce(function (obj) {
      // 调用子组件的方法
      console.log(obj, "好码齐");
      this.$refs.pricingChargeDialog[0].loading = true
      this.dialogVisible('howmuchDialog', false)
      let { payWay, userAuthCode, price } = obj;
      let preParams = {
        ctOrderIds: this.ctOrderIds,
        amount: price,
        payWay,
      }
      //如果好码齐支付为0，直接走现金支付
      if (Utils.eq(price, 0)) {
        preParams.payWay = 2
        this.executePay(preParams)
      } else {
        preParams.attach = { userAuthCode }
        payDTO.payFun(preParams).then(async res => {
          let { code, data } = res
          if (code == 200) {
            this.getConsumeMessage(data.attach.queueId)
          } else {
            this.loading = false
            this.$refs.pricingChargeDialog[0].loading = false
          }
        }).catch(err => {
          this.$refs.pricingChargeDialog[0].loading = false
          this.loading = false
        })
      }
    }, 1000, true),
    /**
     * 查询支付消息
     * 不能用 setInterval
     */
    getConsumeMessage(id) {
      this.handleConsumeMessage(id)
      timeoutTimer('timeoutId2', () => {
        this.closeInterval()
      }, 5 * 60 * 1000);
    },
    /**
   * 执行查询消息
   */
    handleConsumeMessage(id) {
      CommonDTO.consumeMessage({ id }).then(res => {
        if (res.code == 200) {
          let list = isNull(res.data) ? [] : res.data
          let defeatedObj = list.find(item => { return item.type == 1 && item.status == '2' }) //失敗消息
          let isEnd = list.some(item => { return item.type == -1 })
          if (!isNullObj(defeatedObj)) {
            this.$message.error(defeatedObj.text)
            this.closeInterval()
            return;
          }
          if (isEnd) {
            this.$message.success("收费成功！");
            this.closeInterval()
            return;
          }
          // 判断预支付之间是否超过五分钟
          if (this.prePayDate) {
            const date = +new Date()
            const preDate = +new Date(this.prePayDate)
            const disMinute = date - preDate
            const fiveMinute = 5 * 60 * 1000
            this.showOrHideCancelPayBtn(disMinute > fiveMinute)
          }
          if (this.timeoutId1) clearTimeout(this.timeoutId1)
          this.timeoutId1 = setTimeout(() => {
            this.handleConsumeMessage(id)
          }, 1000);
        } else {
          this.closeInterval()
        }
      }).catch(err => {
        this.$message.error('支付超时')
        this.closeInterval()
      })
    },

    showOrHideCancelPayBtn(val) {
      this.showCancelPayBtn = val
    },
    
    // 获取预支付时间
    changePrePayDate(val) {
      this.prePayDate = val
    },
    /**
     * 预支付+支付
     * price 支付金额
     * type 支付方式
     * ctOrderIds 订单id
     */
    handlePay(obj) {
      this.$refs.pricingChargeDialog[0].loading = true
      let { price, payWay, vipCard,offLineObj } = obj
      let preParams = {
        ctOrderIds: this.ctOrderIds,
        amount: price,
        payWay,
        deptId: this.$session.get('deptId'),
        attach: {
          vipCardNumber: vipCard.vipCardNumber,
        },
      }
      if (payWay == 14 && !isNullObj(offLineObj)) {
        preParams.attach = { 
          ...preParams.attach, 
          mdtrtId: offLineObj.ima_mdtrt,
          setlId:offLineObj.ima_setl,
          medfeeSumamt:offLineObj.medfee,
          acctPay:offLineObj.ima_acct,
          wltpayAmt:offLineObj.wltpay,
          fundPaySumamt:offLineObj.fund,
          isMutualAaidPay:!isNull(offLineObj.mdtrt) && !isNull(offLineObj.setl) ? '1' : '0',
          gjMdtrtId:offLineObj.mdtrt,
          gjSetlId:offLineObj.setl,
          gjAcctPay:offLineObj.acct,
         }
      }
      if (Utils.eq(price, 0)) {
        preParams.payWay = 2
      }
      // 非医保支付
      this.executePay(preParams)
    },
    /**
     * 除医保、好码齐其他方式执行收费
     */
    executePay(preParams) {
      payDTO.payFun(preParams).then(async res => {
        let { code, data } = res
        if (code == 200) {
          let time = await CommonDTO.getSystemTimeDTO()
          let obj = { orderPayNumber: data.orderPayNumber, paySuccess: '1', amount: preParams.amount, payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss') }
          payDTO.payCallback(obj).then(result => {
            if (result.code == 200) {
              this.$refs.pricingChargeDialog[0].loading = false
              this.getPatientVisiting().then(res => {
                this.getChargeItem(this.activeOrderId)
              });
              this.$refs.pricingChargeDialog[0].getPayRecord().then(res => {
                let { paid, realPay } = this.$refs.pricingChargeDialog[0].payFrom
                if (Utils.ge(paid, realPay)) {
                  // 支付完成
                  this.$message.success('订单已完成');
                  this.dialogVisible('pricingChargeDialog', false);
                  this.orderHandleCommand('1');
                }
              })
            } else {
              this.$refs.pricingChargeDialog[0].loading = false
            }
          }).catch(() => {
            this.$refs.pricingChargeDialog[0].loading = false
          })
        } else {
          this.$refs.pricingChargeDialog[0].loading = false
        }
      }).catch(() => {
        this.$refs.pricingChargeDialog[0].loading = false
      })
    },
    
    // // 校验订单中的理疗配方中是否存在被禁用的项目
    // // validatePhysioData() {
    // //  return this.recipesList.filter(item => item.recipeType == 3).every(item => {
    // //    return item.items.every(items => items.enableStatus !== 2)
    // //  })
    // // },
    async toCharge () {
      window.$trackTool.track({ v: '1', b: 'his_000008', t: 'his_0001' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.activeOrderId })
      if (!['3', '5'].includes(this.orderInfo.orderSourceType) && this.orderInfo.orderPayFlag === '0') {
        const res = await getActivityList({ orderId: this.activeOrderId  })
        if (res.code == 200 && res.data && ((res.data.orderGiftVOs && res.data.orderGiftVOs.length > 0) || (res.data.orderMultipleVOs && res.data.orderMultipleVOs.length > 0))) {
          let orderMultipleSelectList = this.giftGoodList.map(v => { return v.actNumber })
          orderMultipleSelectList = Array.from(new Set(orderMultipleSelectList))
          this.$refs['activityDialog'].open({
            ...res.data,
            orderId: this.activeOrderId,
            orderMultipleSelectList: orderMultipleSelectList
          })
        } else {
          this.handleCharge()
        }
      } else {
        this.handleCharge()
      }
    },
    async activitySubmit (activity) {
      if (activity.orderMultiple.number) {
        const params = {
          orderId: this.activeOrderId,
          number: activity.orderMultiple.number
        }
        const res = await saveMultipleActivity(params)
        if (res.code === 200) {
          this.dialogObj.activity = activity
          this.handleCharge()
        }
      } else {
        this.dialogObj.activity = activity
        this.handleCharge()
      }
    },
    /**
     * 收费
     */
    async handleCharge() {
      let inventoryFlag = false;
      if (isNull(this.patientInfo.patientId) || isNull(this.doctorInfo.doctorId) || isNull(this.orderInfo.salesUserCode)) return this.$message.error('请先选择患者、开单人和医生')
      // 先更新一下最新数据
      this.getChargeItem(this.activeOrderId).then(async code => {
        if (code == 200) {
          try {
            // 判断是否存在有效订单
            if (this.orderInfo.orderPayFlag == '0') {
              // // if(!this.validatePhysioData()) return this.$message.error('当前订单中存在被禁用的理疗项目')
              let drugList = [] //中药处方商品列表
              let artNos = []
              this.recipesList.forEach(item => {
                item.items && item.items.forEach(obj => {
                  obj.items && obj.items.forEach(kid => { 
                    drugList.push({ ...kid, itemNum: kid.itemTotal })
                    if((isNull(obj.isOwned) || obj.isOwned=='0') && kid.artNo > 0){
                      artNos.push(kid.artNo)
                    }
                  })
                })
              })
              let newDrugList = delSomeObjValue(drugList, 'artNo', 'itemNum')
              // 通过kinId查询商品库存以及禁用标识
              let { data } = await Outpatient.getInventory({doctorId:this.doctorInfo.doctorId, artNos, deptId: this.$session.get('deptId'), goodsType: '0' })
              newDrugList.forEach(drugObj => {
                if (isNull(drugObj.artNo) || drugObj.artNo < 0 || drugObj.artNo == 0) { drugObj.onSale = '0' }
                data.forEach(dataItem => {
                  if (dataItem.artNo == drugObj.artNo) {
                    drugObj.onSale = dataItem.onSale
                    drugObj.inventory = dataItem.inventory
                    drugObj.goodsType = dataItem.goodsType
                  }
                })
              })
              newDrugList = newDrugList.filter(v=>{ return isNull(v.isOwned) || v.isOwned == '0' })
              inventoryFlag = newDrugList.some(kid => { return kid.onSale == '0' || (kid.goodsType == '1' && Utils.lt(kid.inventory, kid.itemNum)) })
              this.drugList = newDrugList
              if (inventoryFlag) {
                this.inventoryTipsDialogShow = true
                return
              }
            }

            this.dialogObj.originalPrice = this.totalPrice
            this.dialogObj.totalPrice = this.computeShowTotalPrice()
            this.dialogObj.orderId = this.activeOrderId
            this.dialogObj.registerPrice = this.registerPrice
            this.dialogObj.version = this.orderPayment.version
            this.dialogObj.couponIds = this.couponObj && this.couponObj.couponIds || null
            this.dialogObj.memberId = this.couponObj &&  this.couponObj.memberId || null
            this.dialogObj.couponPrice = this.couponObj &&  this.couponObj.discountAmount || null
            this.dialogObj.diagnosisList = this.diagnosisList
            this.dialogObj.vipCard = this.vipCard
            this.dialogObj.recipesList = this.recipesList
            this.dialogVisible('pricingChargeDialog', true)
          } catch (error) {
            CommonDTO.saveLogDTO({businessType:'1',errorMsg:error.message})
          }
        }
      })
    },

    /**
     * 零售开单
     * transferFlag 是否为转方
     */
    retailBilling: debounce(async function (transferFlag = false) {
      this.orderInfo = {}
      this.doctorInfo = {}
      this.patientInfo = {}
      this.chargePotential = null
      this.searchFrom.searchValue = ''
      this.searchFrom.date = [this.$moment(this.systemTime).format('YYYY-MM-DD'),this.$moment(this.systemTime).format('YYYY-MM-DD')]
      this.searchSource = '2'
      let { code } = await this.saveVisiting('',false,transferFlag)
      if (code == 200) {
        this.searchFrom.currentPage = 1
        this.activeOrderId = ''
        this.getCurrentOrderInfo()
        this.getCaseDiagnosis()
      }
    }, 500, true),

    /**
     * 获取收费详情
     */
    getChargeDetail() {
      return new Promise(async (resolve, reject) => {
        let { code, data } = await payDTO.getPayDetail({ orderId: this.activeOrderId });
        if (code == 200) {
          resolve()
          this.chargeDetail = isNull(data.payCharge) ? {} : data.payCharge
          this.dealList = isNull(data.details) ? [] : data.details

          // 当前订单状态
          this.activeOrderStatus = (this.backlogList.find(item => item.orderId == this.activeOrderId) || {}).status || ''
          // 获取订单中发票信息
          this.getInvoiceInfo()
        }
      })
    },

    // 获取发票信息
    getInvoiceInfo() {
      this.issueStatusText = ''
      this.issueList = []
      return new Promise(async (resolve, reject) => {
        const { code, data } = await payDTO.getInvoiceList({ orderId: this.activeOrderId })
        if (code == 200 && data) {
          this.getIssueInfo(data || {})
        }
      })
    },

    // 处理发票信息数据
    getIssueInfo(invoiceResponse) {
      const issueStatusInfo = {
        '-1': '待开票',
        '0': '已开票',
        '2': '待开票',
        '3': '已红冲',
        '6': '已作废'
      }
      const issueOrderStatusInfo = {
        '-1': '未开票',
        '0': '部分开票',
        '1': '已开票',
      }
      const orderTypeNameInfo = {
        '1': '中药处方',
        '2': '理疗处方',
        '3': '隐秘处方',
        '4': '非处方项目',
        '15': '中成药处方'
      }
      // 订单类型排序
      const orderTypeSortList = ['1', '15', '2', '4', '3']

      const { status, detailList } = invoiceResponse
      this.issueStatus = status
      this.issueStatusText = issueOrderStatusInfo[status]

      const recipeTypeList = [...new Set(detailList.map(item => item.recipeType))]
      const obj = {}
      recipeTypeList.forEach(el => {
        const sortList = detailList.filter(item => item.recipeType === el).sort((a, b) => a.sort - b.sort)
        obj[el] = sortList.map((item, index) => ({
          ...item,
          titleName: orderTypeNameInfo[el] + (sortList.length > 1 ? (index + 1) : ''),
          orderNumbers: (item.orderNumbers || []).map(items => ({
            ...items,
            statusText: issueStatusInfo[items.invoiceStatus]
          }))
        }))
      })
      this.issueList = orderTypeSortList.map(item => obj[item]).flat().filter(item => !!item)
    },

    /**
     * 实时保存数据
     */
    updateData: debounce(function (val) {
      this.updatePricingInfo();
    }, 200),

    updateDataNum: debounce(function (val, obj) {
      let bol = validParams(val, positiveNum, '请输入数字,保留两位小数')
      if (bol) {
        this.updatePricingInfo().then(async res=>{
          this.getChargeItem(this.activeOrderId)
        })
      } else {
        obj.itemNum = ''
      }
    }, 200),
    updateDataInteger: debounce(function (val, obj) {
      let bol = validParams(val, positiveInteger, '请输入正整数')
      if (bol) {
        this.updatePricingInfo().then(async res=>{
          this.getChargeItem(this.activeOrderId)
        })
      } else {
        obj.itemNum = 1
      }
    }, 200),
    /**
     * 选择非处方项目
     */
    selectOtherItem(val) {
      let otherObj = this.recipesList.find(item => { return item.recipeType == '0' })
      let drugIndex = otherObj.items.findIndex(obj => { return obj.itemId == val })
      if (Utils.gt(drugIndex, -1)) {
        this.$message.error('您已添加过该药品')
        this.drugSearchValue = ''
        return
      }
      let index = this.otherOption.findIndex(item => { return item.itemId == val })
      let item = this.otherOption[index]
      otherObj.items.push({ ...item, itemNum: 1, totalPrice: item.price, remark: '' })
      this.drugSearchValue = ''
      this.otherOption = []
      this.updatePricingInfo().then(res => {
        this.getChargeItem(this.activeOrderId).then(kid => {
          this.$nextTick(() => {
           this.$refs[`otherInput${otherObj.items.length - 1}`] && this.$refs[`otherInput${otherObj.items.length - 1}`][0].$children[0].focus()
           this.$refs[`otherInput${otherObj.items.length - 1}`] && this.$refs[`otherInput${otherObj.items.length - 1}`][0].$children[0].select()
          })
        })
      })
    },

    /**
     * 选择医生
     */
    selectDoctor(val) {
      let item = this.doctorOption.find(v=>{return v.doctorId == val})
      if(!isNullObj(item)){
        if(item.userCode == this.orderInfo.salesUserCode && this.orderInfo.transferFlag){
          this.doctorInfo.doctorCode = ''
          this.doctorInfo.doctorName = ''
          this.doctorInfo.doctorId = ''
            this.$message.error('转方单接待人和医生不能是同一个人')
            return
          }
        this.doctorInfo.doctorName = item.doctorName
        this.doctorInfo.doctorCode = item.doctorCode
        this.getPreRegisPrice(val).then(async data => {
          this.registerPrice = isNull(data) ? 0 : data
          await this.getRevisitRegisterPrice()
          this.saveVisiting(this.activeOrderId)
        })
      }
    },

    // 选择所属医馆
    selectDept(id) {
      if(isNull(id)){
        this.orderInfo.commissionDeptName=''
      }else{
        const commissionDept = this.deptList.find(v => v.value == id)
        this.orderInfo.commissionDeptName = commissionDept && commissionDept.label || ''
      }
      this.saveVisiting(this.activeOrderId)
    },

    /**
     * 选择开单人
     */
    selectUser(val) {
      if(isNull(val)){
        this.orderInfo.salesPerson = ''
        this.orderInfo.salesPersonId = ''
      }else{
        if(val == this.doctorInfo.userCode && this.orderInfo.transferFlag){
          this.orderInfo.salesPerson = ''
          this.orderInfo.salesPersonId = ''
          this.orderInfo.salesUserCode = ''
          this.$message.error('转方单接待人和医生不能是同一个人')
          return
        }
        this.userOptions.forEach(item => {
        if (item.userCode == val) {
          this.orderInfo.salesPerson = item.nickName
          this.orderInfo.salesUserCode = val + ''
          this.orderInfo.salesPersonId = item.userId
        }
      })
      }
      this.saveVisiting(this.activeOrderId)
    },

    /**
     * 获取医生列表
     */
    getDoctorOption: debounce(async function (val) {
      if (isNull(val)) return;
      this.doctorOption = []
      let { code, rows } = await doctorDTO.getDoctorList({ doctorName: val, pageNum: 1, pageSize: 50,status:'0' })
      if (code == 200) {
        this.doctorOption = rows
      }
    }, 500),
    /**
     * 获取开单人列表
     */
    async getUserOption() {
      let { code, rows } = await userList({ deptId: [] });
      if (code == 200) this.userOptions = rows;
    },
    /**
     * 搜索非处方项目
     */
    async getOthers(query) {
      if (isNull(query)) return
      this.otherOption = await drugDTO.getOtherProject({ searchWord: query,deptId:this.$session.get('deptId') });
    },

    /**
     * 选择患者
    */
    async selectPatinet(val) {
      if (Utils.gt(this.patientList.length, 0)) {
        let patient = this.patientList.find(item => {
          return item.patientId == val;
        });
        this.patientInfo = patient;
        this.patientList = [];
        await this.getRevisitRegisterPrice()
        this.saveVisiting(this.activeOrderId)
      }
    },

    /**
     * 根据姓名或电话号码获取患者列表
     * @param {*} name
     * @param {*} phone
     */
    getPatientInfoByName: debounce(async function (name) {
      if (!isNull(name)) {
        let { code, data } = await patientDTO.patientInfom({ name, });
        this.patientList = [];
        if (code == 200) {
          data.forEach(item => { this.$computeAge(item.birthday, item); });
          this.patientList = data;
        }
      } else {
        this.patientList = [];
      }
    }, 300),
    // 根据姓名获取患者列表
    getPatientInfoByPhone: debounce(async function (phone) {
      if (!isNull(phone)) {
        let { code, data } = await patientDTO.patientInfom({ phone, });
        this.patientList = [];
        if (code == 200) {
          data.forEach(item => { this.$computeAge(item.birthday, item); });
          this.patientList = data;
        }
      } else {
        this.patientList = [];
      }
    }, 300),
    /**
     * 选择某条就诊信息
     * 就诊id
     */
    async chooseBacklog(id, status) {
      if (['6', '8'].includes(status)) {
        window.$trackTool.track({ v: '1', b: 'his_000007', t: 'his_0001' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: id })
      }
      this.activeOrderId = id;
      this.chargePotential = null
      this.couponObj = null
      this.getChargeItem(id,true);
      this.getCaseDiagnosis()
      this.getCurrentOrderInfo()
      
    },

    // 获取当前订单信息，用于获取就诊历史列表
    getCurrentOrderInfo(){
      // TODO： 暂时隐藏
      this.historyInfo = {
        currentOrderInfo: {},  // 当前所选择的患者订单信息
        pageNum: 1,  // 当前页
        total: 0,
        historyList: [],
        hasMoreHistoryList: true,
        currentHistoryOrderId: '', // 当前所选择的历史就诊单id
      }
      const currentOrderInfo = this.backlogList.find(item => item.orderId === this.activeOrderId)
      this.historyInfo.currentOrderInfo = currentOrderInfo || {}
      this.getHistoryList(1)
    },

    async getOrderVipCardInfo () {
      if(['4', '-7', '9'].includes(this.orderInfo.status)) {
        return;
      }
      const res = await getOrderVipCardInfo({ orderId: this.activeOrderId })
      if (res.code === 200) {
        this.vipCard.vipCardNumber = res.data.vipCard && res.data.vipCard.vipCardNumber || ''
        this.vipCard.status = res.data.vipCard && res.data.vipCard.status || ''
        this.vipCard.discountRate = res.data.vipCard && res.data.vipCard.discountRate || 100
        this.vipCard.balance = res.data.vipCard && res.data.vipCard.balance || 0
        this.vipCard.discountStatus = res.data.discountStatus || 1

        this.totalAmount = this.computeShowTotalPrice()

        if (this.visibleObj['pricingChargeDialog']) {
          this.$refs['pricingChargeDialog'][0].updateVipCardInfo()
        }
      }
    },
    
    /**
     * 获取历史病历列表
     */
     getHistoryList(isInit = 0) {
      if (!this.historyInfo.hasMoreHistoryList) return
      if (!this.historyInfo.currentOrderInfo.patientName || !this.historyInfo.currentOrderInfo.patientPhone) return
      if (isInit === 1) {
        this.historyInfo.pageNum = 1
      } else {
        this.historyInfo.pageNum++
        this.loading = true
      }
      const startDate = Utils.getFutureDate(-90)
      const endDate = Utils.getFutureDate(0)

      let params = {
        patientName: this.historyInfo.currentOrderInfo.patientName || '',  // 患者名称
        patientPhone: this.historyInfo.currentOrderInfo.patientPhone || '', // 患者电话
        pageNum: this.historyInfo.pageNum,
        pageSize: 20,
        excludeDeptId: '1', // 是否排除医馆Id：0-否，1-是
        startTime: startDate + ' 00:00:00',
        endTime: endDate + ' 23:59:59'
      }
      historyList(params).then(res => {
        let { code, rows, total } = res
        if (code == 200) {
          rows.forEach(item => {
            item.date = item.createTime && item.createTime.slice(2, 10)
            if (item.images != '' && item.images != null) {
              item.images = item.images.split(',')
            }
            if (!isNull(item.doctorAdvice)) {
              let arr = item.doctorAdvice.split('\n')
              item.doctorAdviceArr = arr
            }
            if(!isNull(item.menstrualHistory)){
              item.menstrualHistory = this.handleMenstrualHistoryHtml(JSON.parse(item.menstrualHistory))
            }
          });
          if (params.pageNum > 1) {
            this.historyInfo.historyList = this.historyInfo.historyList.concat(rows)
          } else {
            this.historyInfo.historyList = rows
          }
          // console.log(`%c historyList.length: ${this.historyInfo.historyList.length}, pageNum: ${params.pageNum}`, 'color:red;font-size: 14px')
          this.historyInfo.hasMoreHistoryList = rows.length == 20
          this.historyInfo.total = total || 0
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
   //处理将数组处理成html
   handleMenstrualHistoryHtml(menstrualHistory){
    let html = ''
    menstrualHistory.forEach(item=>{
      if(isObject(item)){
        switch(item.type){
          case 'text':
          html = html+`${html.length==0 ?'' :'，'}${item.text}`
          break;
          case 'pregnant':
            html = html + `${html.length==0 ?'' :'，'}<span id="pregnant">孕${item.pregnancyNum} 产${item.childbirthNum}</span>`;
            break;
          case 'menstruation':
            html = html + `${html.length==0 ?'' :'，'}
              <span id="menstruation" class="flex align-i-c">
                <span id="menarcheAge">${item.menarcheAge}</span>
                <span class="flex flex-col w40 size12 tac ml8 mr8">
                  <span id="menstruationDays">${this.filterMenstrual(item.menstruationDays)}</span>
                  <span class="frasl"></span>
                  <span id="menstrualCycle">${this.filterMenstrual(item.menstrualCycle)}</span>
                </span>
                ${isNull(item.menopauseDate)?'':`<span id="menopauseDate">LMP ${item.menopauseDate}</span>`}
                ${isNull(item.menopauseAge)?'':`<span class='ml8' id="menopauseAge">${item.menopauseAge}</span>`}
              </span>`
            break;
        }
      }
    })
    return html;
    },

    filterMenstrual(val){
      let str = ''
      if(!isEmptyArray(val)){
        if(val.length==1){
            str = val[0]
        }else if(val.length==2){
            str = `${val[0]}~${val[1]}`
        }
      }
      return str;
    },

    //  获取历史病例详情
    async getCurrentHistoryOrderDetail(itemInfo) {
      this.historyInfo.currentHistoryOrderId = itemInfo.orderId || ''
      this.currentHistoryOrderInfo = itemInfo || {}
      this.historyOrderDetailInfo.chooseHistory = {}
      this.historyOrderDetailInfo.orderInfo = {}
      this.historyOrderDetailInfo.doctorInfo = {}
      this.historyOrderDetailInfo.payInfo = {}

      Outpatient.getHistoryDoor({ 
        orderId: this.historyInfo.currentHistoryOrderId || ''
      }).then(res => {
        if(res.code==200){
          if (!_.isEmpty(res.data.projectRecipes)) {
            res.data.drugItems = Common.filterDiagnosis(res.data.projectRecipes, 'drug')
            res.data.chineseMedicineItems = Common.filterDiagnosis(res.data.projectRecipes, 'chineseMedicine')
            res.data.phyItems = Common.filterDiagnosis(res.data.projectRecipes, 'phy')
            res.data.otherItems = Common.filterDiagnosis(res.data.projectRecipes, 'other') || []
          }
          res.data.actList = res.data.actGroups || []
          this.historyOrderDetailInfo.chooseHistory = res.data
          this.historyOrderDetailInfo.orderInfo = res.data.orderDetail.order
          this.historyOrderDetailInfo.doctorInfo = res.data.orderDetail.doctor
          this.historyOrderDetailInfo.payInfo = res.data.payInfo
        }
      })
    },


    /**
     * 选择日期
     */
    dateChange() {
      this.activeOrderId = ''
      this.searchFrom.currentPage = 1
      this.backlogList = []
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });

      this.getCurrentOrderInfo()
    },

    /**
     * 查询收费项目信息
     */
    async getChargeItem(orderId,isLoading=false) {
      this.totalAmount = null
      this.showOrHideCancelPayBtn(false)
      if(isLoading){
        this.centerLoading=true;
      }
      if (isNull(orderId)) return;
      return new Promise(async (resolve, reject) => {
        this.doctorOption = []
        this.refuseList = []
        this.rightTab = 1
        let { code, data } = await getChargeItem({ orderId })
        this.centerLoading=false;
        if (code == 200) {
          if(!isNullObj(this.dialogObj)){
            this.dialogObj.version = data.orderPayment &&  data.orderPayment.version || null
          }
          this.registerPrice = 0
          if (isNull(data.orderDetail.patient)) {
            this.patientInfo = {
              patientName: '',
              phone: '',
              age: '',
              ageMth: '',
              sex: ''
            }
          } else {
            this.patientInfo = data.orderDetail.patient
            this.patientInfo.year = data.orderDetail.patient.age
            this.patientInfo.month = data.orderDetail.patient.ageMth
            this.patientInfo.memberPhone = isNull(data.orderDetail.member) ? '' : data.orderDetail.member.phone
            // this.$computeAge(Utils.timeFormat(this.patientInfo.birthday), this.patientInfo);
          }
          if (!isNull(data.orderDetail.doctor)) {
            this.doctorOption.push({
              doctorId: data.orderDetail.doctor.doctorId,
              doctorName: data.orderDetail.doctor.doctorName
            })
          }
          if(!isNull(data.orderDetail.member)){
            this.getCouponList(data.orderDetail.member.phone)
          }
          if(data && data.orderDetail && data.orderDetail.order && !isNull(data.orderDetail.order.salesUserCode)){
            if(this.userOptions.findIndex(item=>item.userCode==data.orderDetail.order.salesUserCode) === -1){
              this.userOptions.push({
                userCode: data.orderDetail.order.salesUserCode,
                nickName: data.orderDetail.order.salesPerson,
                disabled:true
              })
            }
          }
          this.deliveryObj = isNull(data.delivery) ? {} : data.delivery;
          if (!isNull(this.deliveryObj) && !isNullObj(this.deliveryObj)) {
            let { provinceName, cityName, regionName, scopeName, detailedAddress, consigneeName, phone } = this.deliveryObj
            this.deliveryObj.addressDetail = `${consigneeName}${phone}${provinceName}${cityName}${regionName}${isNull(scopeName) ? '' : scopeName}${detailedAddress}`
          }
          this.orderPayment = isNull(data.orderPayment) ? {} : data.orderPayment
          this.doctorInfo = isNull(data.orderDetail) ? {} : (isNull(data.orderDetail.doctor) ? {} : data.orderDetail.doctor)
          this.orderInfo = isNull(data.orderDetail) ? {} : data.orderDetail.order
          this.recipesList = isNull(data.paymentRecipes) ? [] : data.paymentRecipes

          const otherGoodsRecipes = this.recipesList.find(v => { return v.recipeType === '0' })
          if (otherGoodsRecipes) {
            const giftGoodList = otherGoodsRecipes.items.filter(v => { return v.commodityType === 1 })
            this.giftGoodList = giftGoodList
          }

          this.actList = isNull(data.actGroups) ? [] : data.actGroups
          this.patientRemark = isNull(data.orderPayment) ? '' : data.orderPayment.patientRemark
          this.deptRemark = isNull(data.orderPayment) ? '' : data.orderPayment.deptRemark
          if (!isNull(data.examineRecords) && !isEmptyArray(data.examineRecords)) {
            this.refuseList = data.examineRecords.filter(item => { return item.status == 2 })
          }
          if (this.orderInfo.orderSourceType != '0' && this.orderInfo.orderSourceType != '5') {
            this.registerPrice = this.doctorInfo.registeredPrice
            if (this.orderInfo.orderSourceType == '2' && [null, undefined, ''].includes(this.orderInfo.commissionDeptId)) {
              this.orderInfo.commissionDeptId = Number(sessionStorage.getItem('deptId'))
              const commissionDept = this.deptList.find(v => v.value == this.orderInfo.commissionDeptId)
              this.orderInfo.commissionDeptName = commissionDept && commissionDept.label || ''
            }
          }
          this.presDrugDeliveryStatus = data.presDrugDeliveryStatus;

          this.processBOS = data.processBOS && data.processBOS || [];


          this.drugWayDeliveryBOS = data.drugWayDeliveryBOS || [];

          this.discountObj = data.discountBindRecord

          this.getRegisterWaitPay()
          this.computeWeightAndTotal(this.recipesList);
          await this.getChargeDetail(orderId)
        } else {
          this.registerPrice = 0
        }
        if(this.orderInfo.status ==  '8' ){
          this.getChargePotential()
        }
        this.getBingCoupon().then(res=>{
          if(isNull(res) || isNull(res.cantUseReason)){
            resolve(code)
          }
          this.totalAmount = this.computeShowTotalPrice()
          // this.totalAmount = data.totalPrice
        })
        await this.getOrderVipCardInfo()
      })
    },
    /**
     * 更新划价单信息
     */
    async updatePricingInfo() {
      this.loading = true
      this.computeWeightAndTotal(this.recipesList)
      return new Promise(async (resolve, reject) => {
        let params = {
          orderId: this.activeOrderId,
          orderPayment: {
            orderId: this.activeOrderId,
            deptRemark: this.deptRemark,
            patientRemark: this.patientRemark
          },
          paymentRecipes: this.recipesList,
          actGroups: this.actList,
          delivery: (isNull(this.deliveryObj) || isNullObj(this.deliveryObj)) ? null : this.deliveryObj,
        }
        await saveCharge(params).then(res => {
          resolve(res)
          this.loading = false
        })
      })
    },
    /**
     * 保存就诊信息
     * orderId 就诊id
     * flag 是否为补录
     */
    saveVisiting(orderId = '', flag = false,transferFlag = false) {
      this.centerLoading = true
      return new Promise((resolve, reject) => {
        // orderType就诊类型：0-门诊就诊，4-零售开单，5-网诊就诊，12-续方就诊
        let parmas = { ...this.patientInfo, ...this.doctorInfo, orderId, deptId: this.$session.get('deptId'), orderType: isNull(this.orderInfo.orderType) ? '4' : this.orderInfo.orderType }
        if (!isNull(this.orderInfo) && !isNullObj(this.orderInfo)) {
          let { commissionDeptId, commissionDeptName, salesPersonId, salesPerson, salesUserCode } = this.orderInfo
          parmas.commissionDeptId = commissionDeptId
          parmas.commissionDeptName = commissionDeptName
          parmas.salesPersonId = salesPersonId
          parmas.salesPerson = salesPerson
          parmas.salesUserCode = salesUserCode
        }
        // if (flag) parmas.replenishRecipel = '1'
        parmas.price = isNull(this.registerPrice) ? 0 : this.registerPrice
        if(transferFlag) {parmas.transferFlag = transferFlag}
        quickPrescriptionApi(parmas).then(res => {
          resolve(res)
          this.searchFrom.currentPage = 1
          this.getPatientVisiting().then(res => {
            this.getChargeItem(this.activeOrderId)
            this.getCaseDiagnosis()
          });
        })
      })
    },

    /**
     * 搜索就诊信息
     */
    searchBacklog: debounce(function (e) {
      this.total = 0
      this.searchFrom.currentPage = 1
      let lastYear = this.$moment(this.systemTime).subtract(1, 'years')
      this.startDate = Utils.startOfDay(lastYear)
      this.endDate = Utils.endOfDay(this.$moment(this.systemTime))
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });
    }, 300),
    /**
     * 查询就诊信息
     */
    getPatientVisiting(startDate, endDate) {
      return new Promise(async (resolve, reject) => {
        this.isShowTips = isNull(this.searchFrom.searchValue) ? false : true
        let params = {
          ...this.searchFrom,
          // startDate: isNull(this.searchFrom.searchValue) ? Utils.startOfDay(this.searchFrom.date[0]) : this.startDate,
          // endDate: isNull(this.searchFrom.searchValue) ? Utils.endOfDay(this.searchFrom.date[1]) : this.endDate,
          searchSource: this.searchSource,
        } //查询来源:0-门诊，1-收费，2-收费待办
        if(!isNull(this.searchFrom.searchValue) && this.searchFrom.date[0] == this.$moment(this.systemTime).format('YYYY-MM-DD')){
          params.startDate = this.startDate
          params.endDate = this.endDate
        }else{
          params.startDate = Utils.startOfDay(this.searchFrom.date[0])
          params.endDate = Utils.endOfDay(this.searchFrom.date[1])
        }

        let { code, data } = await getOutPatientListApi(params);
        if (code == 200) {
          this.backlogList = this.searchFrom.currentPage == 1 ? data : [...this.backlogList, ...data];
          if (isNull(this.activeOrderId)) {
            this.activeOrderId = isEmptyArray(data) ? '' : data[0].orderId
          }

          // 获取当前患者信息及历史就诊列表
          this.getCurrentOrderInfo()

          this.isLoadMore = Utils.lt(data.length, this.searchFrom.pageSize) ? false : true
          this.isMore = false
          if (isEmptyArray(this.backlogList)) this.disabled = true
          resolve()
        }
      })
    },

    /**
     * 全部待办切换
     */
    backlogHandleClick(tab, event) {
      this.searchFrom.currentPage = 1
      this.backlogList = []
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });
      this.historyInfo = {
        currentOrderInfo: {},  // 当前所选择的患者订单信息
        pageNum: 1,  // 当前页
        total: 0,
        historyList: [],
        hasMoreHistoryList: true,
        currentHistoryOrderId: '', // 当前所选择的历史就诊单id
      }
    },
    /**
     * 切换就诊信息患者
     */
    changeBacklog(item) {
      this.activeOrderId = item.orderId
      this.getCurrentOrderInfo()
    },
    /**
     * 清空患者信息
     */
    clearPatient() {
      this.patientInfo = {}
      if (!isNull(this.doctorInfo.doctorId)) {
        this.getPreRegisPrice(this.doctorInfo.doctorId).then(async data => {
          this.registerPrice = isNull(data) ? 0 : data
        })
      }
    },
    /**
     * 关闭弹框
     */
    dialogVisible(name, bol) {
      let visibleObj = this.visibleObj;
      name = name || this.currentLevelData.name;
      visibleObj[name] = bol != undefined ? bol : !visibleObj[name];
      this.$set(this, "visibleObj", visibleObj);
      this.setDialogLevel(name)
      this.getLevelData(name);
    },
    /**
     * 弹框确认
     */
    confirmUpdateData(data) {
      let currentLevelData = this.currentLevelData;
      currentLevelData.confirmfn && this[currentLevelData.confirmfn](data);
    },
    // 设置弹窗层级
    setDialogLevel(currentLevel) {
      let visibleObj = this.visibleObj;
      let levelData = this.levelData;
      let that = this;
      if (this.visibleObj[currentLevel]) {
        levelData.map(v => {
          // 设置当前层的level为1，其余visible为true的level依次递增
          // enter confirm操作的始终是level为1的dialog
          if (v.name == currentLevel) {
            v.level = 1
          } else if (that.visibleObj[v.name]) {
            v.level = Utils.bigNumber(v.level, '+', 1)
          }
        })
      } else {
        levelData.map(v => {
          // 当前dialog关闭，则设置level为0， 其余visible为true的level依次减一
          if (v.name == currentLevel) {
            v.level = 0
          } else if (that.visibleObj[v.name] && Utils.gt(v.level, 0)) {
            v.level = Utils.bigNumber(v.level, '-', 1)
          }
        })
      }

      this.$set(this, 'levelData', levelData)
    },
    // 获取当前层级 及其Data
    getLevelData(name) {
      let visibleObj = this.visibleObj;
      let levelData = this.levelData;
      let obj = {};
      let currentLevelData = levelData.filter(v => {
        return v.level == 1
      });
      obj = {
        ...currentLevelData[0],
      }
      this.$set(this, 'visibleObj', visibleObj)
      this.$set(this, 'currentLevelData', obj)
    },
    /**
     * 补录处方
     */
    additionalPrescription() {
      if (isNull(this.patientInfo.patientId) || isNull(this.doctorInfo.doctorId)) return this.$message.error('请先填写患者和医生信息')
      this.dialogObj.orderId = this.activeOrderId
      this.dialogObj.doctorInfo = this.doctorInfo
      this.dialogObj.patientInfo = this.patientInfo
      this.dialogObj.orderInfo = this.orderInfo
      this.dialogObj.registerPrice = this.registerPrice
      this.dialogObj.deliveryObj = this.deliveryObj
      this.dialogVisible('additionalPrescriptionDialog', true)
    },
    /**
     * 加工弹框确认
     */
    processingDialogConfirmfn(list) {
      this.recipesList = list;
      this.updatePricingInfo().then(res => {
          this.dialogVisible('processingDialog', false)
          this.getChargeItem(this.activeOrderId)
      })
    },
    /**
     * 快递弹框确认
     */
    deliveryDialogConfirmfn(deliveryFrom) {
      this.deliveryObj = { ...deliveryFrom, orderId: this.activeOrderId }
      this.dialogVisible('deliveryDialog', false)
      this.updatePricingInfo().then(res => {
        this.getChargeItem(this.activeOrderId)
      })
    },
    /**
     * 删除非处方项目、加工费
     * item 每项处方信息 obj药品项目信息  type删除细项类型：0-挂号费，1-加工费，2-快递费，3-非处方项目细项 4中药处方 5隐秘处方 6理疗处方
     */
    async delItem(type, item = {}, obj = {}) {
      console.log(item, obj);
      let params = {
        orderId: this.activeOrderId,
        paymentItemType: type,
        recipeType: item.recipeType,
      }
      switch (type) {
        case '1':
          params.itemId = item.recipeId;//处方id
          break;
        case '3':
          params.itemId = obj.spuId;//非处方项目细项货号
          break;
      }
      let { code, data } = await deletePaymentItem(params);
      if (code == 200) {
        this.getChargeItem(this.activeOrderId)
      }
    },
    /**
     * 删除处方
     */
    async delProject(item) {
      let { code, data } = await deletePaymentProject({ orderPaymentRecipeId: item.paymentRecipeId, recipePaymentType: item.recipeType })
      if (code == 200) {
        this.$message.success('删除成功')
        this.getChargeItem(this.activeOrderId);
      }
    },
    /**
     * 计算重量和价格
     */
    computeWeightAndTotal(list) {
      computeWeight(list, this);
      computeRecipesTotalPricingDetails(list, this);
      computePricingTotalNew(this)
    },
    /**
     * 订单完成
     */
    completeOrder() {
      this.dialogVisible('pricingChargeDialog', false)
      this.getChargeItem(this.activeOrderId)
    },

    /**
     * 删除草稿信息
     */
    draftDelete: debounce(function () {
      msgboxWarning(this, {
        message: "删除后不可恢复，确定删除改草稿？",
        confirmFn: async () => {
          {
            let { code, data } = await draftDelete({ orderId: this.activeOrderId })
            if (code == 200) {
              this.activeOrderId = ''
              this.searchFrom.currentPage = 1
              this.getPatientVisiting().then(res => {
                this.getChargeItem(this.activeOrderId)
              });
              this.getCurrentOrderInfo()
            }
          }
        },
        cancelFn: () => {
        },
      });

    }, 800, true),
    /**
     * 切换右边状态栏
     */
    changeRightTab(val) {
      this.rightTab = val
      if (val == 2) {
        this.getCaseDiagnosis().then(res => {
          if (res.code = 200) {
            this.getRecipeContinue()
          }
        })
      } else if (val == 3) {
        getTransferOrderInfo({ combinedNum: this.chargeDetail.orderCombinedNum }).then(res => {
          if (res.code == 200) {
            Object.keys(this.transferOrderInfo).map(k => {
              if (res.data.hasOwnProperty(k)) {
                this.transferOrderInfo[k] = res.data[k]
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    /**
     * 获取续方信息
     */
    async getRecipeContinue() {
      this.imgLsit = []
      let { code, data } = await prescriptionDTO.getRecipeContinue({ orderId: this.activeOrderId })
      if (code == 200) {
        if (!isNull(data.images)) {
          this.imgLsit = data.images.split(',');
        }
      }
    },
    /**
     * 修改患者
     */
    editPatient() {
      this.addPatientType = 'edit'
      this.patientDialogTitle = '修改患者'
      this.dialogVisible('addPatientDialog', true)
    },
    /**
    * 新增患者
    */
    handleAddPatient() {
      this.patientDialogTitle = '新增患者'
      this.addPatientType = 'add'
      this.dialogVisible('addPatientDialog', true)
    },
    /**
    * 新增患者确认
    */
    addPatientComfirm(data) {
      let { patientId, patientName, phone, age, ageMth, sex, birthday } = data
      this.patientInfo = {
        patientId, patientName, phone, sex, birthday, year: age, month: ageMth

      }
      this.dialogVisible('addPatientDialog', false)
      this.saveVisiting(this.activeOrderId)
    },

    // 复制门诊处方
    async copyHandle(itemInfo) {
      msgboxWarning(this, {
        message: "请确认是否将此门诊单处方复制到当前收费单？",
        confirmFn: async () => {
          const params = {
            sourceOrderId: itemInfo.orderId || '',  // 复制的门诊单Id
            orderId: this.activeOrderId || ''  // 当前收费单Id
          }
          const res = await Outpatient.copyOutpatientOrder(params)
          if (res.code == 200) {
            this.$message.success('复制成功')
            // this.chooseBacklog(this.activeOrderId)
            this.getPatientVisiting().then(res => {
              this.chooseBacklog(this.activeOrderId)
            });
          }
        },
        cancelFn: () => {
        }
      });

    },
    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 打印完成
     */
    printSuccess() {

    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },

    // 打印就诊历史门诊单处方
    printHistoryOrderHandle(value, itemInfo) {
      this.orderHandleCommand(value, itemInfo.orderId )
    },

    //批量打印完成
    printSuccessBatch() {
      this.$message.success('打印成功消息发送成功')
    },
    /**
     * 划价单打印
     * val 1小票 2处方
     */
    orderHandleCommand(val, orderId) {
      // 是否是打印当前收费单页面右上角打印  true:代表打印当前收费单（页面右上角的打印按钮）  false：代表打印当前患者的历史门诊单（页面左下角就诊历史）
      const isPrintCurrentMoneyOrder = typeof orderId === 'object'
      console.log('isPrintCurrentMoneyOrder', isPrintCurrentMoneyOrder)
      this.printType = val
      switch (val) {
        case '1': //小票
          this.isBatch = false;
          this.printorderType = '4'
          this.printOrderId = this.activeOrderId
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '2': //处方
          this.isBatch = true
          let printListObj = []
          if (isPrintCurrentMoneyOrder) {
            this.recipesList.forEach(item => {
              if (item.recipeType != '0') {
                printListObj.push({
                  printType: val,
                  id: item.recipeId,
                  orderType: item.recipeType == '3' ? '2' : '1'
                })
              }
            })
          } else {
            // 就诊历史门诊单处方打印
            const projectRecipes = this.historyOrderDetailInfo.chooseHistory.projectRecipes || []
            projectRecipes.forEach(item => {
              if (item.recipeType != '0') {
                printListObj.push({
                  printType: val,
                  id: item.orderCaseProjectRecipeId,
                  orderType: item.recipeType == '3' ? '2' : '1'
                })
              }
            })
            const actHasOrderList = this.historyOrderDetailInfo.chooseHistory.actList.filter(v => { return ![null, undefined, ''].includes(v.orderCaseProjectRecipeId) })
            actHasOrderList.forEach(item => {
              printListObj.push({
                printType: val,
                id: item.orderCaseProjectRecipeId,
                orderType: '2'
              })
            })
          }
          this.printListObj = printListObj
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '3': //病历
          this.isBatch = false;
          this.printorderType = '4'
          this.printType = '6'
          this.printOrderId = isPrintCurrentMoneyOrder ? this.activeOrderId : orderId
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '4': //结算单
          this.isBatch = false;
          this.printorderType='1'
          this.printType = '8'
          this.printOrderId = this.activeOrderId
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '5': //收费清单
          this.isBatch = false;
          this.printorderType='1'
          this.printType = '7'
          this.printOrderId = this.activeOrderId
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '6': // 发票
          this.$refs.invoiceDetail.open(this.activeOrderId)
          break;
      }
    },
    // 打印发票
    invoicePrint (orderId) {
      this.isBatch = false;
      this.printorderType='21'
      this.printType = '1'
      this.printOrderId = orderId
      this.$nextTick(() => {
        this.$refs.printDia.useDefaultPrint()
      })
    },
    /**
     * 打印、删除处方
     * id 处方id
     * 
     */
    handleCommand(val, item) {
      if (val == 1) {
        this.recipePrint(item)
      } else if (val == 2) {
        msgboxWarning(this, {
          message: "确定删除该处方？",
          confirmFn: async () => {
            {
              this.delProject(item)
            }
          },
          cancelFn: () => {
          },
        });
      }
    },
    /**
     * 处方打印
     */
    recipePrint(item){
      let { recipeId, recipeType, actNumber } = item
      this.printOrderId = recipeId
      this.isBatch = false
      this.printType = '2'
      if (![null, undefined, ''].includes(recipeType)) {
        switch(recipeType){
          case '1':  //中药
            this.printorderType = '1'
            break;
          case '3':  //理疗
            this.printorderType = '2'
            break;
          case '4':  //中成药
            this.printorderType = '1'
            break;
        }
      } else if (![null, undefined, ''].includes(actNumber)) {
        this.printorderType = '2'
      }
      
      this.$nextTick(() => {
        this.$refs.printDia.useDefaultPrint()
      })
    },
    // 删除套餐
    removeActivity (actNumber) {
      this.$confirm('是否确定删除该套餐？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const activityIndex = this.actList.findIndex(v => v.actNumber == actNumber)
        this.actList.splice(activityIndex, 1)

        this.updatePricingInfo().then(() => {
          this.$message.success('删除成功')
          this.getChargeItem(this.activeOrderId);
        })
      }).catch(() => {})
    },
    /**
     * 关闭划价单
     */
    closePricing: debounce(async function () {
      msgboxWarning(this, {
        message: "确定关闭收费单？",
        confirmFn: async () => {
          {
            let { code, data } = await switchOrderInfo({ orderId: this.activeOrderId, switchState: '0' })
            if (code == 200) {
              this.searchFrom.currentPage = 1
              this.getPatientVisiting().then(res => {
                this.getChargeItem(this.activeOrderId)
              });
            }
          }
        },
        cancelFn: () => {},
      });
    }, 500, true),
    /**
     * 补录处方确认
     */
    additionalPrescriptionDialogConfimfn(deliveryObj) {
      if (!isNull(deliveryObj) && !isNullObj(deliveryObj)) this.deliveryObj = deliveryObj
      this.dialogVisible('additionalPrescriptionDialog', false)
      this.searchFrom.currentPage = 1
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
        this.getCaseDiagnosis()
      });
    },
    /**
     * 再来一单
     */
    async handleAgin() {
      let { code, data } = await buyAgain({ orderId: this.activeOrderId });
      if (code == 200) {
        this.searchFrom.date = [this.$moment(this.systemTime).format('YYYY-MM-DD'),this.$moment(this.systemTime).format('YYYY-MM-DD')]
        this.searchSource = '2'
        this.activeOrderId = data.orderId
        this.searchFrom.currentPage = 1
        this.getPatientVisiting().then(res => {
          this.getChargeItem(this.activeOrderId)
        });
        this.getCurrentOrderInfo()
      }
    },
    /**
     * 退费
     */
    async handleRefund() {
      this.dialogObj.orderId = this.activeOrderId
      await this.getChargeItem(this.activeOrderId)
      if (this.orderInfo.status == '8') {
        // 部分收费
        let record = [] // 支付记录
        let refundTotal = 0 //已退
        let total = 0 //已收
        let isHasYB = false //判断是否含有医保支付
        let { code, data } = await payDTO.getRefundItem({ orderId: this.activeOrderId, orderType: 4 })
        if (code == 200) {
          data.record && data.record.forEach((item, index) => {
            total = this.$bigNumber(item.payPrice, '+', total)
            if (item.payWay == '1') { isHasYB = true }
            if (item.payWay == '1') {
              if (isNull(item.refundList) || isEmptyArray(item.refundList)) {
                // 医保无退款记录
                record.push(item)
              }
            } else {
              record.push(item)
            }
          })
          data.refundTaskDetailList && data.refundTaskDetailList.forEach(item => {
            refundTotal = this.$bigNumber(item.amount, '+', refundTotal)
          })
          this.dialogObj.record = record
          this.dialogObj.refundTotal = this.$bigNumber(total, '-', refundTotal)
          this.dialogObj.resource = 2
          this.dialogObj.isHasYB = isHasYB
        }
        this.dialogVisible('chargeRefundDialog', true)
      }
      if (this.orderInfo.status == '4') {
        // 全部收费
        this.dialogVisible('refundItemDialog', true)
      }
    },
    /**
     * 退费项目确定
     */
    refundItemDialogComfirm(obj) {
      let { refundTotal, record, isHasYB ,refundList} = obj
      this.dialogObj.refundTotal = refundTotal
      this.dialogObj.record = record
      this.dialogObj.orderId = this.activeOrderId
      this.dialogObj.resource = 0
      this.dialogObj.isHasYB = isHasYB
      this.dialogObj.refundList = refundList
      this.dialogVisible('chargeRefundDialog', true)
      if(isHasYB){
        this.dialogVisible('refundItemDialog', false)
      }
    },
    /**
     * 退款完成
     */
    chargeRefundDialogConfirm() {
      this.dialogVisible('chargeRefundDialog', false);
      this.dialogVisible('refundItemDialog', false)
      this.searchFrom.currentPage = 1
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });
    },
    /**
     * 挂号费修改
     */
    registerInput: debounce(function (val) {
      let bol = validParams(val, positiveInteger, '请输入正整数')
      if (bol) {
        this.saveVisiting(this.activeOrderId)
      }
    }, 300),
    /**
     * 拒接订单
     */
    refuseOrder() {
      this.dialogObj.orderId = this.activeOrderId
      this.dialogVisible('refuseDialog', true)
    },
    /**
     * 拒接确认
     */
    refuseDialogConfirmfn() {
      this.dialogVisible('refuseDialog', false)
      this.searchFrom.currentPage = 1
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });
    },
    /**
     * 取消订单
     */
    async cancelCtOrder() {
      this.dialogVisible('pricingChargeDialog', false)

      let orderMultipleSelectList = this.giftGoodList.map(v => { return v.actNumber })
      orderMultipleSelectList = Array.from(new Set(orderMultipleSelectList))

      if (orderMultipleSelectList.length > 0) {
        const res = await cannelMultipleActivity({ orderId: this.activeOrderId, number: orderMultipleSelectList[0] })
      }

      let { code, data } = await orderDTO.cancelCtOrder({ orderId: this.activeOrderId })
      if (code == 200) {
        this.searchFrom.currentPage = 1
        this.searchSource = '1'
        this.getPatientVisiting().then(res => {
          this.getChargeItem(this.activeOrderId)
        });
      }
    },
    async updatePage () {
      this.getPatientVisiting().then(res => {
        this.getChargeItem(this.activeOrderId)
      });
    },
    /**
     * 获取加工费
     */
    async getProcessingPrice(processItem, doseNum, weight) {
      let { bagNumSum, processName } = processItem
      let params = {
        number: doseNum,
        processingType: processName,
        weight: this.$bigNumber(doseNum, '*', weight),
        bagNumberSum: bagNumSum
      }
      if (processName != '熬药') params.bagNumber = '0'
      await processingPrice(params).then(async res => {
        if (res.code == 200) {
          processItem.processPrice = res.data
          await this.updatePricingInfo();
        }
      })
    },
    /**
     * 剂量失焦
     */
    async drugDoseNumBlur(val, item) {
      if (isNull(item.doseNum)) return;
      let bol = validParams(item.doseNum, positiveInteger, '请输入正整数')
      if (!bol) {
        item.doseNum = 1
      }
      let { process, processFlag, weight, doseNum, isYlcp } = item
      if (processFlag == '1' && isYlcp == '0') {
        process.bagNumSum = this.$bigNumber(doseNum, '*', process.bagNum)
        await this.getProcessingPrice(process, doseNum, weight)
      } else {
        await this.updatePricingInfo();
      }
      this.getChargeItem(this.activeOrderId, true);
    },
    /**
     * 获取医生挂号费
     */
    getPreRegisPrice(id) {
      return new Promise(async (resolve, reject) => {
        let { code, data } = await doctorDTO.getPreRegisPrice({ doctorId: id })
        if (code == 200) {
          resolve(data)
        }
      })
    },
    /**
     * 推送订单（通过审核）
     */
    async examineContinuePass() {
      let { code, data } = await prescriptionDTO.examineContinuePass({ orderId: this.activeOrderId, originalPrice: this.totalPrice, bargainPrice: this.totalPrice })
      if (code == 200) {
        this.$message.success('推送订单成功')
        this.getPatientVisiting().then(res => {
          this.getChargeItem(this.activeOrderId)
        });
      }
    },
    /**
     * 重新收费
     */
    async chargeAgin() {
      let { code, data } = await switchOrderInfo({ orderId: this.activeOrderId, switchState: '1' })
      if (code == 200) {
        this.searchFrom.currentPage = 1
        this.getPatientVisiting().then(res => {
          this.getChargeItem(this.activeOrderId)
        });
      }
    },
    /**
     * 非处方项目enter事件
     */
    numberEnter() {
      this.$refs.otherSearchRef.focus()
    },
    transferOrderOpen() {
      this.$refs['TransferOrderDialog'].open(this.chargeDetail.orderCombinedNum)
    },
    // 转单成功
    transferOrderSuccess() {
      this.searchFrom.currentPage = 1
      this.getPatientVisiting().then(() => {
        this.getChargeItem(this.activeOrderId)
      });
    },
    /**
     * 复制
     */
    handleCopy(obj){
      let address = `${obj.consigneeName}${obj.phone}${obj.provinceName}${obj.cityName}${obj.regionName}${obj.scopeName || ''}${obj.detailedAddress}`
      if(isNull(address)) return;
      copy(address)
    },
    /** 配方单 */
    showFormulaOrder() {
      this.$refs['formulaOrder'].open()
    },
    //共济取消
    gjCancel(){
      this.$refs.pricingChargeDialog[0].getPayRecord().then(res => {
        // let { paid, realPay } = this.$refs.pricingChargeDialog[0].payFrom
        // if (Utils.ge(paid, realPay)) {
        //   // 支付完成
        //   this.$message.success('订单已完成');
        //   this.dialogVisible('pricingChargeDialog', false);
        //   this.orderHandleCommand('1');
        // }
      })
    },
    SMSDialogClose(){
      this.$refs.pricingChargeDialog[0].loading = false
      this.SMSDialogObj.show = false
    },
    //短信验证确定
    smsVerificationConfirm(obj){
      let { phone,price,code,curAmount} = obj
      if (isNull(curAmount) || curAmount == 0) {
        this.$message.error('会员钱包余额为0')
        return
      }
      this.$refs.SMSDialog.loading = true
      let preParams = {
        ctOrderIds: this.ctOrderIds,
        amount: price,
        payWay:'8',
        attach:{ phone, smsCode: code}
      }
      payDTO.payFun(preParams).then(async res => {
          let { code, data } = res
          if (code == 200) {
            let time = await CommonDTO.getSystemTimeDTO()
            let parmas = { orderPayNumber: data.orderPayNumber, paySuccess: '1', amount: preParams.amount, payTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss') }
            payDTO.payCallback(parmas).then(result => {
            if (result.code == 200) {
              this.$refs.pricingChargeDialog[0].loading = false
              this.SMSDialogObj.show = false
              this.getPatientVisiting().then(res => {
                this.getChargeItem(this.activeOrderId)
              });
              this.$refs.pricingChargeDialog[0].getPayRecord().then(res => {
                let { paid, realPay } = this.$refs.pricingChargeDialog[0].payFrom
                if (Utils.ge(paid, realPay)) {
                  // 支付完成
                  this.$message.success('订单已完成');
                  this.dialogVisible('pricingChargeDialog', false);
                  this.orderHandleCommand('1');
                }
              })
            } else {
              this.$refs.SMSDialog.loading = false
              this.$refs.pricingChargeDialog[0].loading = false
            }
          }).catch(() => {
            this.$refs.pricingChargeDialog[0].loading = false
            this.$refs.SMSDialog.loading = false
          })
          } else {
            this.loading = false
            this.$refs.SMSDialog.loading = false
          }
        }).catch(err => {
          this.$refs.SMSDialog.loading = false
          this.loading = false
        })
    },
    //优惠券
    async handleCoupon(val){
      if(isNull(this.doctorInfo.doctorId)){
        return this.$message.error('请先选择医生')
      }
      this.dialogObj = {}
      if(val == 0){
        this.dialogObj.memberPhone = this.patientInfo.memberPhone
        this.dialogObj.orderId = this.orderInfo.orderId
        this.cancellationCouponShow = true
      }else if(val == 1){
        this.dialogObj.phone = this.couponObj.memberPhone
        this.dialogObj.activeIds = this.couponObj.couponIds
        this.dialogObj.orderId = this.orderInfo.orderId
        this.couponListShow = true
      }else if(val == 2){
        let params = { orderId: this.orderInfo.orderId, couponIds: this.couponObj.couponIds, memberId: this.couponObj.memberId }
        let {code,data} = await unbindCoupon(params)
        if(code==200){
          this.couponDialogObj = {}
          this.couponObj = null
          this.getChargeItem(this.activeOrderId);
        }
      }
    },
    openScanDialog(){
      this.howmuchVisibleObj.howmuchDialog = true
    },
    howmuchDialogObjClose(){
      this.howmuchVisibleObj.howmuchDialog = false
    },
    async couponScanSuccess(obj){
      if(isNull(obj.userAuthCode)) return;
      function decryptNumberToString(num) {
        const strNum = num.toString();
        let decryptedString = '';
        // 每 3 位数字代表一个字符的 Unicode 编码
        for (let i = 0; i < strNum.length; i += 3) {
          const charCode = parseInt(strNum.substr(i, 3));
          decryptedString += String.fromCharCode(charCode);
        }
        return decryptedString;
      }
      obj.userAuthCode = decryptNumberToString(obj.userAuthCode);
      console.log(obj,99999);
      // obj.userAuthCode = obj.userAuthCode.replace(/-/g, '_');
      let arr =  obj.userAuthCode.split('&')
      this.couponDialogObj = {}
      let params = { orderId:this.orderInfo.orderId, couponId:arr[0], memberId:arr[1] }
      let {code,data} = await couponDetail(params)
      if(code==200){
        // data['doctorNamesStr'] = isNull(data.doctorNames) ? '全部医生' : isEmptyArray(data.doctorNames) ? '暂无' : data.doctorNames.join('、')
        // data['deptNamesStr'] = isNull(data.deptNames) && isNull(data.deptIds) ? '全部门店' : isEmptyArray(data.deptNames) ? '暂无' : data.deptNames.join('、')
        // data['medicineNamesStr'] = isNull(data.medicineNames) && isNull(data.medicineCodes) ? '全部商品可用' : isEmptyArray(data.medicineNames) ? '暂无' : data.medicineNames.join('、')
        // this.couponDialogObj = {...data,memberId:params.memberId} || {}
        // this.couponDialogShow = true
        this.howmuchVisibleObj.howmuchDialog = false
        this.dialogObj.phone = data.memberPhone
        this.dialogObj.activeIds = data.cantUseReason ? [] : [data.couId]
        this.dialogObj.orderId = this.orderInfo.orderId
        this.couponListShow = true
        if(data.cantUseReason){ 
          this.$message.error('当前券不可用，请重新选择')
        }
      }else{
        this.howmuchVisibleObj.howmuchDialog = false
        setTimeout(() => {
          this.howmuchVisibleObj.howmuchDialog = true
        }, 200);
      }
    },
    async couponDialogConfirm(obj){
      let params = { orderId: this.orderInfo.orderId, memberId: obj.memberId, couponIds: obj.couponIds }
      let { code, data } = await bindCoupon(params)
      if(code == 200){
        this.couponObj = obj;
        this.couponDialogShow = false
        this.couponListShow = false
        this.cancellationCouponShow = false
        this.totalAmount = this.computeShowTotalPrice()
        if(this.dialogObj.resource == 'charge'){
          this.toCharge()
        }
      }
    },
    //查询订单绑定的优惠券
    getBingCoupon(){
      return new Promise(async (resolve, reject) => {
        if(this.disabled == '1'){
          resolve(null)
          return;
        }
        let {code,data} = await getBingCoupon({orderId:this.activeOrderId})
        if(code == 200 && data){
          this.couponObj = {
            memberPhone: data[0] ? data[0].memberPhone : null,
            memberId: data[0] ? data[0].memberId : null,
            couponIds: data.map(item => item.couId),
            discountAmount: data.reduce((a, b) => { return this.$bigNumber(a,'+',b.discountAmount,2)}, 0)
          }
          if(data && data.some(item => item.cantUseReason)){
            msgboxWarning(this, {
              title: "优惠券不可用",
              message: '订单已变更，当前优惠券不可用，请重新选择。',
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showCancelButton: true,
              confirmButtonText: '重新选择',
              cancelButtonText: '暂不选择',
              confirmFn: () => {
                let params = { orderId: this.orderInfo.orderId, couponIds: this.couponObj.couponIds, memberId: this.couponObj.memberId }
                unbindCoupon(params).then(res=>{
                  if(res.code==200){
                    this.couponDialogObj = {}
                    this.couponObj = null
                  }
                })
              },
              cancelFn: () => {
                let params = { orderId: this.orderInfo.orderId, couponIds: this.couponObj.couponIds, memberId: this.couponObj.memberId }
                unbindCoupon(params).then(res=>{
                  if(res.code==200){
                    this.couponDialogObj = {}
                    this.couponObj = null
                  }
                })
              },
           });
          }
          resolve(data)
        }else{
          this.couponObj = null
          resolve(null)
        }
      })
    },
    //议价不平
    chargeSuggestion(price){
      msgboxWarning(this, {
          message: `应单价摊分规则，实收金额可能浮动，请按系统显示收费${price}。`,
          confirmButtonText: "知道了",
          showClose:false,
          showCancelButton:false,
          confirmFn: async () => {
            this.handleCharge()
          },
         
        });
    },
    cancellationConfirm(id){
      this.dialogObj.phone = this.patientInfo.memberPhone
      this.dialogObj.orderId = this.activeOrderId
      this.dialogObj.patientName = this.patientInfo.patientName
      id == '1' ? this.openScanDialog() : this.couponListShow = true
    },
    cancellationCouponClose(){
      this.cancellationCouponShow = false
      this.getChargeItem(this.activeOrderId);
    },
    couponListClose(resource){
      this.couponListShow = false
      if(resource && resource == 'charge'){
        this.toCharge()
      }
    },
    handleOrder(val){
      if(val == 1){ this.retailBilling() }
      if(val == 2){ this.retailBilling(true) }
    },
    // 更新会员信息
    updateMemberInfoHandle(rechargeMemberInfo = {}) {
      this.rechargeMemberInfo = deepClone(rechargeMemberInfo)
    },
    updateOrderNumHandle(orderNum = ''){
      this.payOrRefundSuccessDialog.payOrRefundOrderNum = orderNum
      this.$message.success('充值成功！')
      this.recommendCancel('cnf')
    },
    showPaySuccessDialogHandle(type){
      this.payOrRefundSuccessDialog = {
        ...this.payOrRefundSuccessDialog,
        payOrRefundSuccessDialog:true,
        type,
      }
    },
    recommendCancel(action){
      let params = {
        s:'CRPW',
        c:'his',
        t:this.$moment().valueOf(),
        info:{
          orderNo:this.orderInfo.orderId,
          envTim:this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          opt:action,
          patId:this.patientInfo.patientId,
          vId:this.memberInfo.memberId
        }
      }
      buriedPoint(params).then(res=>{})
      this.showRechargeDialog = false
    },
    recommendRechargeOpen(){
      this.memberInfo = {}
      //查询当前患者下的会员信息
      memberInfo(this.patientInfo.patientId).then(res=>{
        if(res.code == 200){
          this.memberInfo = res.data
          let params = {
            s:'ORPW',
            c:'his',
            t:this.$moment().valueOf(),
            info:{
              orderNo:this.orderInfo.orderId,
              envTim:this.$moment().format('YYYY-MM-DD HH:mm:ss'),
              crowd:this.chargePotential.crowd,
              vId:res.data.memberId,
              patId:this.patientInfo.patientId
            }
          }
          buriedPoint(params).then(res=>{})
        }
      })
      this.showRechargeDialog = true
    },
    async getChargePotential(){
      if(isNull(this.patientInfo.patientId)) return;
         // 充值金额列表
      let rechargeList = process.env.VUE_APP_ENV === 'production' ? productRechargeList : testRechargeList
      let topLevel = []
      rechargeList.forEach(v=>{topLevel.push(v.amt)})
      let params = {
        companyId:10,
        param:{
          patientId: this.patientInfo.patientId + '',
          payAmount:Number(this.computeShowTotalPrice()),
          needRevisit:this.orderInfo.revisitFlag == '0' ? 0 : 1,
          topLevel:topLevel.join(',')
        },
        tpCode:'TPH001'
      }
      let {errorCode,data} = await touchPoint(params)
      if(errorCode == '0000'){
        this.chargePotential = data
      }
    },
    // 打开扫码支付
    async toSharePay () {
      let inventoryFlag = false;
      if (isNull(this.patientInfo.patientId) || isNull(this.doctorInfo.doctorId) || isNull(this.orderInfo.salesUserCode)) return this.$message.error('请先选择患者、开单人和医生')
      // 先更新一下最新数据
      this.getChargeItem(this.activeOrderId).then(async code => {
        if (code == 200) {
          try {
            // 判断是否存在有效订单
            if (this.orderInfo.orderPayFlag == '0') {
              // // if(!this.validatePhysioData()) return this.$message.error('当前订单中存在被禁用的理疗项目')
              let drugList = [] //中药处方商品列表
              let artNos = []
              this.recipesList.forEach(item => {
                item.items && item.items.forEach(obj => {
                  obj.items && obj.items.forEach(kid => { 
                    drugList.push({ ...kid, itemNum: kid.itemTotal })
                    if((isNull(obj.isOwned) || obj.isOwned=='0') && kid.artNo > 0){
                      artNos.push(kid.artNo)
                    }
                  })
                })
              })
              let newDrugList = delSomeObjValue(drugList, 'artNo', 'itemNum')
              // 通过kinId查询商品库存以及禁用标识
              let { data } = await Outpatient.getInventory({doctorId:this.doctorInfo.doctorId, artNos, deptId: this.$session.get('deptId'), goodsType: '0' })
              newDrugList.forEach(drugObj => {
                if (isNull(drugObj.artNo) || drugObj.artNo < 0 || drugObj.artNo == 0) { drugObj.onSale = '0' }
                data.forEach(dataItem => {
                  if (dataItem.artNo == drugObj.artNo) {
                    drugObj.onSale = dataItem.onSale
                    drugObj.inventory = dataItem.inventory
                    drugObj.goodsType = dataItem.goodsType
                  }
                })
              })
              newDrugList = newDrugList.filter(v=>{ return isNull(v.isOwned) || v.isOwned == '0' })
              inventoryFlag = newDrugList.some(kid => { return kid.onSale == '0' || (kid.goodsType == '1' && Utils.lt(kid.inventory, kid.itemNum)) })
              this.drugList = newDrugList
              if (inventoryFlag) {
                this.inventoryTipsDialogShow = true
                return
              }
            }
            
            this.$refs['sharePayDialog'].open({
              orderId: this.activeOrderId,
              price: this.computeShowTotalPrice()
            })
          } catch (error) {
            CommonDTO.saveLogDTO({businessType:'1',errorMsg:error.message})
          }
        }
      })
    },
    //查询患者从今天到未来的 未支付+挂号费≥1的挂号单列表
    async getRegisterWaitPay() { 
      this.registerWaitPayList = []
      if(isNull(this.patientInfo.patientId)) return;
      let { code,data } = await getRegisterWaitPay({patientName: this.patientInfo.patientName,phone: this.patientInfo.phone,})
      if(code == 200){
        let list = []
        data.currentDeptRegisterList && data.currentDeptRegisterList.forEach(item=>{
          list.push({...item,isCurrentDept:true})
        })
        data.otherDeptRegisterList && data.otherDeptRegisterList.forEach(item=>{
          list.push({...item,isCurrentDept:false})
        })
        this.registerWaitPayList = list
      }
    },
    registerDialogClose(flag = false){
      this.registerDialogObj.show=false
      if(flag){
        this.getRegisterWaitPay()
      }
    },
    openRegisterDialog(){
      this.registerDialogObj.list = this.registerWaitPayList
      this.registerDialogObj.show=true
    },
    commandCharge(val){
      if(val==1){
        if(this.usableList.length > 0 && isNull(this.discountObj) && isNull(this.couponObj) && !this.disabled){
          this.dialogObj.resource = 'charge'
          this.cancellationConfirm('2')
        }else{
          this.toCharge()
        }
      }else{
        this.toSharePay()
      }
    },
    commandDiscount(val){
      switch (val) {
        case '1':
          discountBind({orderId:this.activeOrderId,discountType:4}).then(res=>{
            if(res.code == 200){this.getChargeItem(this.activeOrderId) }
          })
          break;
        case '2':
          discountBind({orderId:this.activeOrderId,discountType:5}).then(res=>{
            if(res.code == 200){this.getChargeItem(this.activeOrderId) }
          })
          break;
        case '3':
          let { discountAmount,discountRate } = this.discountObj || {}

          const noStackingActivityList = this.actList.filter(v => { return v.discountOverlay === 2 })

          let amount = this.totalPrice
          if (!isNull(this.registerPrice)) {
            amount = this.$bigNumber(this.totalPrice,'-',this.registerPrice)
          }
          noStackingActivityList.forEach(v => {
            amount = this.$bigNumber(amount,'-',v.totalPrice)
          })

          this.giftGoodList.forEach(v => {
            amount = this.$bigNumber(amount,'-',(Math.round(v.itemTotal * 0.01 * 100) / 100))
          })


          this.bargainDialog.amount = amount
          this.bargainDialog.discountRate = isNull(discountRate) ? 100 : discountRate
          this.bargainDialog.discountAmount = isNull(discountAmount) ? 0 : discountAmount
          this.bargainDialog.discountType = 1
          this.bargainDialog.registerPrice = this.registerPrice
          this.bargainDialog.noStackingActivityList = noStackingActivityList
          this.bargainDialog.giftGoodList = this.giftGoodList
          this.bargainDialog.show = true
          break;
        case '4':
          this.$refs['vipCardScan'].open()
          break;
      }
    },
    async vipCardScanSuccess(code){
      if (code) {
        const res = await getVipCardInfo({ vipCardNumber: code })
        if (res.code === 200) {
          this.bargainDialog.amount = isNull(this.registerPrice) ?  this.totalPrice : this.$bigNumber(this.totalPrice,'-',this.registerPrice)
          this.bargainDialog.discountRate = isNull(res.data.discountRate) ? 100 : res.data.discountRate
          let temp = this.$bigNumber(this.bargainDialog.discountRate,'/',100)
          this.bargainDialog.discountAmount = this.$bigNumber(this.bargainDialog.amount,'-',this.$bigNumber(this.bargainDialog.amount,'*',temp,2)) 
          this.bargainDialog.discountType = 3
          this.bargainDialog.vipCardNumber = res.data.vipCardNumber
          this.bargainDialog.show = true
        }
      }
    },
    bargainDialogClose(){
      this.bargainDialog.show = false
    },
    async cancelDiscount(){
      let {code} = await discountUnbind({orderId:this.activeOrderId})
      if(code == 200){
        this.getChargeItem(this.activeOrderId)
      }
    },
    bargainDialogSave(val){
      console.log(val,222);
      let {discountAmount,discountRate,discountType,vipCardNumber}= val
      let obj = { orderId:this.activeOrderId,discountAmount,discountRate,discountType,vipCardNumber }
      discountBind(obj).then(res=>{
        if(res.code == 200){
          this.bargainDialog.show = false
          this.getChargeItem(this.activeOrderId) 
        }
      })
    },
    async getCouponList(phone){
      this.usableList = []
      if(isNull(phone) || isNull(this.doctorInfo.doctorId)) return
      let {code,data} = await getCouponList({ orderId: this.activeOrderId,phone,couponIds: []})
      if(code ==200){
        this.usableList = data.usableList || []
      }
    },
    async getRevisitRegisterPrice() {
      if (isNull(this.doctorInfo.doctorId) || isNull(this.patientInfo.patientId)) return;
      let { code, data } = await getRevisitRegisterPrice({
        deptId: this.$session.get('deptId'),
        doctorId: this.doctorInfo.doctorId,
        patientId: this.patientInfo.patientId,
        registerType: '0'
      })
      if (code == 200) {
        this.registerPrice = data.finalPrice
      }
    },
    openQRCode(qrText){
      this.$refs['commonQRCode'].open(qrText)
    },
    openComboSelect () {
      this.$refs['comboSelect'].open()
    },
    // 选择套餐
    async submitComboSelect (info) {
      const hasActivity = this.actList.some(v => v.actNumber === info.number)
      if (hasActivity) {
        this.$message.error('套餐已添加')
        return
      }
      const physioList = info.physios.filter(v => {
        v['drugType'] = 1
        v['itemName'] = v.drugName
        v['spuCommonName'] = v.drugName
        v['itemUnit'] = v.unit
        v['executeCount'] = null
        v['executeDesc'] = null
        v['executeInterval'] = null
        v['physioExtendJson'] = {
          acupointinfoList: [],
          executionMode: v.executionMode,
          onlyNum: v.groupCount,
          perUnit: v.perUnit,
          perUnitCount: v.perUnitCount,
          physioIntervalEnum: null,
          soldNum: v.executionMode === 20 ? v.itemNum * v.groupCount : v.itemNum
        }
        return v.itemNum > 0
      })
      const drugList = info.drugs.filter(v => {
        v['drugType'] = 2
        v['itemName'] = v.drugName
        v['spuCommonName'] = v.drugName
        v['itemUnit'] = v.unit
        v['executeCount'] = null
        v['executeDesc'] = null
        v['executeInterval'] = null
        return v.itemNum > 0
      })

      const activity = {
        actNumber: info.number,
        actCseName: info.cseName,
        actCount: info.count,
        totalPrice: Math.round(info.count * info.price * 100) / 100,
        items: [...physioList, ...drugList]
      }
      this.actList.push(activity)

      this.updatePricingInfo().then(() => {
        this.$message.success('套餐添加成功')
        this.getChargeItem(this.activeOrderId);
        this.$refs['comboSelect'].close()
      })
    }
  }
}
</script>

<style lang="less" scoped src="./PricingDetails.less"></style>